/**
 * Verse Customizer — product page behavior.
 *
 * One instance of this runs per `.vc-root` on the page (Shopify sections
 * can theoretically repeat, though normally there's one per product
 * page). Manual-picker verse text comes from bible-api.com live, since
 * bundling the whole Bible into every product page isn't practical.
 * Mystery-mode verses are a small curated list baked in below.
 */
(function () {
  "use strict";

  var BIBLE_API_BASE = "https://bible-api.com";

  // Catholic (Douay-Rheims) book order. Books flagged catholic exist in the Douay-Rheims only.
  var BOOKS = [
    { id: "GEN", name: "Genesis" }, { id: "EXO", name: "Exodus" }, { id: "LEV", name: "Leviticus" },
    { id: "NUM", name: "Numbers" }, { id: "DEU", name: "Deuteronomy" }, { id: "JOS", name: "Joshua" },
    { id: "JDG", name: "Judges" }, { id: "RUT", name: "Ruth" }, { id: "1SA", name: "1 Samuel" },
    { id: "2SA", name: "2 Samuel" }, { id: "1KI", name: "1 Kings" }, { id: "2KI", name: "2 Kings" },
    { id: "1CH", name: "1 Chronicles" }, { id: "2CH", name: "2 Chronicles" }, { id: "EZR", name: "Ezra" },
    { id: "NEH", name: "Nehemiah" }, { id: "TOB", name: "Tobit", catholic: true }, { id: "JDT", name: "Judith", catholic: true },
    { id: "EST", name: "Esther" }, { id: "JOB", name: "Job" }, { id: "PSA", name: "Psalms" },
    { id: "PRO", name: "Proverbs" }, { id: "ECC", name: "Ecclesiastes" }, { id: "SNG", name: "Song of Solomon" },
    { id: "WIS", name: "Wisdom", catholic: true }, { id: "SIR", name: "Sirach", catholic: true }, { id: "ISA", name: "Isaiah" },
    { id: "JER", name: "Jeremiah" }, { id: "LAM", name: "Lamentations" }, { id: "BAR", name: "Baruch", catholic: true },
    { id: "EZK", name: "Ezekiel" }, { id: "DAN", name: "Daniel" }, { id: "HOS", name: "Hosea" },
    { id: "JOL", name: "Joel" }, { id: "AMO", name: "Amos" }, { id: "OBA", name: "Obadiah" },
    { id: "JON", name: "Jonah" }, { id: "MIC", name: "Micah" }, { id: "NAM", name: "Nahum" },
    { id: "HAB", name: "Habakkuk" }, { id: "ZEP", name: "Zephaniah" }, { id: "HAG", name: "Haggai" },
    { id: "ZEC", name: "Zechariah" }, { id: "MAL", name: "Malachi" }, { id: "1MA", name: "1 Maccabees", catholic: true },
    { id: "2MA", name: "2 Maccabees", catholic: true }, { id: "MAT", name: "Matthew" }, { id: "MRK", name: "Mark" },
    { id: "LUK", name: "Luke" }, { id: "JHN", name: "John" }, { id: "ACT", name: "Acts" },
    { id: "ROM", name: "Romans" }, { id: "1CO", name: "1 Corinthians" }, { id: "2CO", name: "2 Corinthians" },
    { id: "GAL", name: "Galatians" }, { id: "EPH", name: "Ephesians" }, { id: "PHP", name: "Philippians" },
    { id: "COL", name: "Colossians" }, { id: "1TH", name: "1 Thessalonians" }, { id: "2TH", name: "2 Thessalonians" },
    { id: "1TI", name: "1 Timothy" }, { id: "2TI", name: "2 Timothy" }, { id: "TIT", name: "Titus" },
    { id: "PHM", name: "Philemon" }, { id: "HEB", name: "Hebrews" }, { id: "JAS", name: "James" },
    { id: "1PE", name: "1 Peter" }, { id: "2PE", name: "2 Peter" }, { id: "1JN", name: "1 John" },
    { id: "2JN", name: "2 John" }, { id: "3JN", name: "3 John" }, { id: "JUD", name: "Jude" },
    { id: "REV", name: "Revelation" }
  ];

  var TRANSLATION_NAMES = { kjv: "KJV", web: "WEB", niv: "NIV", dra: "DRA" };
  window.CLVRY_BOOKS = BOOKS; // read by the owner-only Studio link maker

  // fill/ink drive the illustrated-SVG fallback (Hoodie/Cap/Socks, which
  // don't have real product photos yet). photoFilter drives the actual
  // Tee photo (tee-front/back-blank.png) — only Black is a true photo;
  // the rest are CSS-filter approximations of that same photo until
  // real per-color Printify exports exist. Names match the store's
  // actual Color variant option values exactly.
  var COLORS = {
    Black: { fill: "#141210", ink: "light", photoFilter: "none" },
    White: { fill: "#f4f1e9", ink: "dark", photoFilter: "invert(1) brightness(1.05)" },
    Pink: { textInk: "#4a4640", fill: "#e8b9c4", ink: "dark", photoFilter: "brightness(3.4) sepia(0.2) saturate(3.5) hue-rotate(300deg)" },
    Lavender: { textInk: "#4a4640", fill: "#c7bfe0", ink: "dark", photoFilter: "brightness(3.2) sepia(0.25) saturate(2.4) hue-rotate(220deg)" },
    Anthracite: { fill: "#3d3b38", ink: "light", photoFilter: "brightness(1.55) saturate(0.25)" },
    "Dark Heather Grey": { fill: "#6e6b67", ink: "light", photoFilter: "brightness(1.9) saturate(0.15)" },
    "Dark Heather Blue": { fill: "#4b5568", ink: "light", photoFilter: "brightness(1.9) saturate(1.6) hue-rotate(200deg)" },
    Ash: { fill: "#c9c5be", ink: "dark", photoFilter: "brightness(3.0) saturate(0.12)" },
    "Carolina Blue": { textInk: "#4a4640", fill: "#7ba7d4", ink: "dark", photoFilter: "brightness(2.6) saturate(2.2) hue-rotate(180deg)" },
    "Graphite Heather": { fill: "#5c5a56", ink: "light", photoFilter: "brightness(1.75) saturate(0.15)" },
    "Light Pink": { textInk: "#4a4640", fill: "#eec6d0", ink: "dark", photoFilter: "brightness(3.6) sepia(0.2) saturate(2.6) hue-rotate(300deg)" }
  };

  // Neckline is punched out of the body silhouette as a second subpath,
  // rendered with fill-rule: evenodd — a proper crew-neck hole rather
  // than a notch cut into the shoulder line.
  var NECKLINE_TEE =
    "M117,30 C117,23.9 109.4,18.9 100,18.9 C90.6,18.9 83,23.9 83,30 " +
    "C83,36.1 90.6,41.1 100,41.1 C109.4,41.1 117,36.1 117,30 Z";
  var NECKLINE_HOODIE =
    "M118,32 C118,25.7 109.9,20.6 100,20.6 C90.1,20.6 82,25.7 82,32 " +
    "C82,38.3 90.1,43.4 100,43.4 C109.9,43.4 118,38.3 118,32 Z";

  var BODY_TEE =
    "M66,26 C48,28 30,34 22,46 C14,58 14,74 18,88 C20,94 30,96 40,92 " +
    "C48,89 56,84 60,80 L62,218 C62,222 65,224 70,224 L130,224 " +
    "C135,224 138,222 138,218 L140,80 C144,84 152,89 160,92 " +
    "C170,96 180,94 182,88 C186,74 186,58 178,46 C170,34 152,28 134,26 " +
    "L66,26 Z";

  var BODY_HOODIE =
    "M64,28 C46,30 26,36 18,50 C10,62 10,80 15,96 C18,103 30,105 42,100 " +
    "C50,96 56,90 60,84 L58,214 C58,219 62,222 68,222 L132,222 " +
    "C138,222 142,219 142,214 L140,84 C144,90 150,96 158,100 " +
    "C170,105 182,103 185,96 C190,80 190,62 182,50 C174,36 154,30 136,28 " +
    "L64,28 Z";

  var GARMENT_SHAPES = {
    Tee: BODY_TEE + " " + NECKLINE_TEE,
    Hoodie: BODY_HOODIE + " " + NECKLINE_HOODIE,
    Cap:
      "M40,120 C40,66 66,32 100,32 C134,32 160,66 160,120 Z " +
      "M18,116 C18,116 55,136 100,136 C145,136 182,116 182,116 " +
      "C182,116 172,148 128,150 L72,150 C28,148 18,116 18,116 Z",
    Socks:
      "M76,10 L124,10 L124,30 C124,30 124,90 128,110 " +
      "C133,132 148,148 158,166 C170,187 178,204 172,216 " +
      "C167,227 152,231 138,229 C120,226 104,216 92,200 " +
      "C82,187 76,170 76,150 Z"
  };

  var HOOD_SHAPE =
    "M72,30 C72,10 84,2 100,2 C116,2 128,10 128,30 " +
    "C128,34 124,36 120,34 C114,30 108,28 100,28 " +
    "C92,28 86,30 80,34 C76,36 72,34 72,30 Z";

  var POCKET_SHAPE =
    "M74,128 L126,128 C126,128 132,138 132,150 L132,166 " +
    "C120,177 80,177 68,166 L68,150 C68,138 74,128 74,128 Z";

  // Curated mystery-mode pool. Small and hand-picked on purpose — see
  // memory/project notes for why (not a substitute for the full Bible,
  // just a themed shortcut for people without a specific verse in mind).
  var THEMES = {
    "Hope": { desc: "for new beginnings", verses: [
      { ref: "Jeremiah 29:11", kjv: "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end.", web: "For I know the thoughts that I think toward you, says Yahweh, thoughts of peace, and not of evil, to give you hope and a future.", asv: "For I know the thoughts that I think toward you, saith Jehovah, thoughts of peace, and not of evil, to give you hope in your latter end.", niv: "For I know the plans I have for you, declares the LORD, plans to prosper you and not to harm you, plans to give you hope and a future." },
      { ref: "Romans 15:13", kjv: "Now the God of hope fill you with all joy and peace in believing, that ye may abound in hope, through the power of the Holy Ghost.", web: "Now may the God of hope fill you with all joy and peace in believing, that you may abound in hope in the power of the Holy Spirit.", asv: "Now the God of hope fill you with all joy and peace in believing, that ye may abound in hope, in the power of the Holy Spirit.", niv: "May the God of hope fill you with all joy and peace as you trust in him, so that you may overflow with hope by the power of the Holy Spirit." },
      { ref: "Psalm 42:11", kjv: "Why art thou cast down, O my soul? and why art thou disquieted within me? hope thou in God: for I shall yet praise him, who is the health of my countenance, and my God.", web: "Why are you in despair, my soul? Why are you disturbed within me? Hope in God! For I shall still praise him, the saving help of my countenance, and my God.", asv: "Why art thou cast down, O my soul? And why art thou disquieted within me? Hope thou in God; for I shall yet praise him, who is the help of my countenance, and my God.", niv: "Why are you downcast, O my soul? Why so disturbed within me? Put your hope in God, for I will yet praise him, my Savior and my God." },
      { ref: "Lamentations 3:23", kjv: "They are new every morning: great is thy faithfulness.", web: "They are new every morning. Great is your faithfulness.", asv: "They are new every morning; great is thy faithfulness.", niv: "They are new every morning; great is your faithfulness." },
      { ref: "Hebrews 11:1", kjv: "Now faith is the substance of things hoped for, the evidence of things not seen.", web: "Now faith is assurance of things hoped for, proof of things not seen.", asv: "Now faith is assurance of things hoped for, a conviction of things not seen.", niv: "Now faith is being sure of what we hope for and certain of what we do not see." },
      { ref: "Romans 8:28", kjv: "And we know that all things work together for good to them that love God, to them who are the called according to his purpose.", web: "We know that all things work together for good for those who love God, to those who are called according to his purpose.", asv: "And we know that to them that love God all things work together for good, even to them that are called according to his purpose.", niv: "And we know that in all things God works for the good of those who love him, who have been called according to his purpose." }
    ]},
    "Strength": { desc: "for hard days", verses: [
      { ref: "Isaiah 40:31", kjv: "But they that wait upon the LORD shall renew their strength; they shall mount up with wings as eagles; they shall run, and not be weary; and they shall walk, and not faint.", web: "but those who wait for Yahweh will renew their strength. They will mount up with wings like eagles. They will run, and not be weary. They will walk, and not faint.", asv: "but they that wait for Jehovah shall renew their strength; they shall mount up with wings as eagles; they shall run, and not be weary; they shall walk, and not faint.", niv: "But those who hope in the LORD will renew their strength. They will soar on wings like eagles; they will run and not grow weary, they will walk and not be faint." },
      { ref: "Philippians 4:13", kjv: "I can do all things through Christ which strengtheneth me.", web: "I can do all things through Christ, who strengthens me.", asv: "I can do all things in him that strengtheneth me.", niv: "I can do everything through him who gives me strength." },
      { ref: "Psalm 46:1", kjv: "God is our refuge and strength, a very present help in trouble.", web: "God is our refuge and strength, a very present help in trouble.", asv: "God is our refuge and strength, a very present help in trouble.", niv: "God is our refuge and strength, an ever-present help in trouble." },
      { ref: "Joshua 1:9", kjv: "Have not I commanded thee? Be strong and of a good courage; be not afraid, neither be thou dismayed: for the LORD thy God is with thee whithersoever thou goest.", web: "Haven't I commanded you? Be strong and courageous. Don't be afraid. Don't be dismayed, for Yahweh your God is with you wherever you go.", asv: "Have not I commanded thee? Be strong and of good courage; be not affrighted, neither be thou dismayed: for Jehovah thy God is with thee whithersoever thou goest.", niv: "Have I not commanded you? Be strong and courageous. Do not be terrified; do not be discouraged, for the LORD your God will be with you wherever you go." },
      { ref: "Psalm 27:1", kjv: "The LORD is my light and my salvation; whom shall I fear? the LORD is the strength of my life; of whom shall I be afraid?", web: "Yahweh is my light and my salvation. Whom shall I fear? Yahweh is the strength of my life. Of whom shall I be afraid?", asv: "Jehovah is my light and my salvation; whom shall I fear? Jehovah is the strength of my life; of whom shall I be afraid?", niv: "The LORD is my light and my salvation—whom shall I fear? The LORD is the stronghold of my life—of whom shall I be afraid?" },
      { ref: "Deuteronomy 31:6", kjv: "Be strong and of a good courage, fear not, nor be afraid of them: for the LORD thy God, he it is that doth go with thee; he will not fail thee, nor forsake thee.", web: "Be strong and courageous. Don't be afraid or scared of them; for Yahweh your God himself is who goes with you. He will not fail you nor forsake you.", asv: "Be strong and of good courage, fear not, nor be affrighted at them: for Jehovah thy God, he it is that doth go with thee; he will not fail thee, nor forsake thee.", niv: "Be strong and courageous. Do not be afraid or terrified because of them, for the LORD your God goes with you; he will never leave you nor forsake you." }
    ]},
    "Wisdom": { desc: "for decisions", verses: [
      { ref: "Proverbs 3:5", kjv: "Trust in the LORD with all thine heart; and lean not unto thine own understanding.", web: "Trust in Yahweh with all your heart, and don't lean on your own understanding.", asv: "Trust in Jehovah with all thy heart, and lean not upon thine own understanding.", niv: "Trust in the LORD with all your heart and lean not on your own understanding." },
      { ref: "James 1:5", kjv: "If any of you lack wisdom, let him ask of God, that giveth to all men liberally, and upbraideth not; and it shall be given him.", web: "But if any of you lacks wisdom, let him ask of God, who gives to all liberally and without reproach, and it will be given to him.", asv: "But if any of you lacketh wisdom, let him ask of God, who giveth to all liberally and upbraideth not; and it shall be given him.", niv: "If any of you lacks wisdom, he should ask God, who gives generously to all without finding fault, and it will be given to him." },
      { ref: "Proverbs 3:6", kjv: "In all thy ways acknowledge him, and he shall direct thy paths.", web: "In all your ways acknowledge him, and he will make your paths straight.", asv: "In all thy ways acknowledge him, And he will direct thy paths.", niv: "In all your ways acknowledge him, and he will make your paths straight." },
      { ref: "Proverbs 16:9", kjv: "A man's heart deviseth his way: but the LORD directeth his steps.", web: "A man's heart plans his course, but Yahweh directs his steps.", asv: "A man's heart deviseth his way; but Jehovah directeth his steps.", niv: "In his heart a man plans his course, but the LORD determines his steps." },
      { ref: "Proverbs 4:7", kjv: "Wisdom is the principal thing; therefore get wisdom: and with all thy getting get understanding.", web: "Wisdom is supreme. Get wisdom. Yes, though it costs all your possessions, get understanding.", asv: "The beginning of wisdom is: Get wisdom; yea, with all thy getting get understanding.", niv: "Wisdom is supreme; therefore get wisdom. Though it cost all you have, get understanding." },
      { ref: "Romans 12:2", kjv: "And be not conformed to this world: but be ye transformed by the renewing of your mind, that ye may prove what is that good, and acceptable, and perfect, will of God.", web: "Don't be conformed to this world, but be transformed by the renewing of your mind, so that you may prove what is the good, well-pleasing, and perfect will of God.", asv: "And be not fashioned according to this world: but be ye transformed by the renewing of your mind, that ye may prove what is the good and acceptable and perfect will of God.", niv: "Do not conform any longer to the pattern of this world, but be transformed by the renewing of your mind. Then you will be able to test and approve what God's will is—his good, pleasing and perfect will." }
    ]},
    "Comfort": { desc: "for grief or loss", verses: [
      { ref: "Psalm 34:18", kjv: "The LORD is nigh unto them that are of a broken heart; and saveth such as be of a contrite spirit.", web: "Yahweh is near to those who have a broken heart, and saves those who have a crushed spirit.", asv: "Jehovah is nigh unto them that are of a broken heart, and saveth such as are of a contrite spirit.", niv: "The LORD is close to the brokenhearted and saves those who are crushed in spirit." },
      { ref: "Matthew 11:28", kjv: "Come unto me, all ye that labour and are heavy laden, and I will give you rest.", web: "Come to me, all you who labor and are heavily burdened, and I will give you rest.", asv: "Come unto me, all ye that labor and are heavy laden, and I will give you rest.", niv: "Come to me, all you who are weary and burdened, and I will give you rest." },
      { ref: "2 Corinthians 1:3", kjv: "Blessed be God, even the Father of our Lord Jesus Christ, the Father of mercies, and the God of all comfort.", web: "Blessed be the God and Father of our Lord Jesus Christ, the Father of mercies and God of all comfort.", asv: "Blessed be the God and Father of our Lord Jesus Christ, the Father of mercies and God of all comfort.", niv: "Praise be to the God and Father of our Lord Jesus Christ, the Father of compassion and the God of all comfort." },
      { ref: "Psalm 23:1", kjv: "The LORD is my shepherd; I shall not want.", web: "Yahweh is my shepherd: I shall lack nothing.", asv: "Jehovah is my shepherd; I shall not want.", niv: "The LORD is my shepherd, I shall not be in want." },
      { ref: "1 Peter 5:7", kjv: "Casting all your care upon him; for he careth for you.", web: "casting all your worries on him, because he cares for you.", asv: "casting all your anxiety upon him, because he careth for you.", niv: "Cast all your anxiety on him because he cares for you." },
      { ref: "Revelation 21:4", kjv: "And God shall wipe away all tears from their eyes; and there shall be no more death, neither sorrow, nor crying, neither shall there be any more pain: for the former things are passed away.", web: "He will wipe away every tear from their eyes. Death will be no more; neither will there be mourning, nor crying, nor pain any more. The first things have passed away.", asv: "and he shall wipe away every tear from their eyes; and death shall be no more; neither shall there be mourning, nor crying, nor pain, any more: the first things are passed away.", niv: "He will wipe every tear from their eyes. There will be no more death or mourning or crying or pain, for the old order of things has passed away." }
    ]},
    "Peace": { desc: "for anxious minds", verses: [
      { ref: "Philippians 4:7", kjv: "And the peace of God, which passeth all understanding, shall keep your hearts and minds through Christ Jesus.", web: "And the peace of God, which surpasses all understanding, will guard your hearts and your thoughts in Christ Jesus.", asv: "And the peace of God, which passeth all understanding, shall guard your hearts and your thoughts in Christ Jesus.", niv: "And the peace of God, which transcends all understanding, will guard your hearts and your minds in Christ Jesus." },
      { ref: "John 14:27", kjv: "Peace I leave with you, my peace I give unto you: not as the world giveth, give I unto you. Let not your heart be troubled, neither let it be afraid.", web: "Peace I leave with you. My peace I give to you; not as the world gives, give I to you. Don't let your heart be troubled, neither let it be fearful.", asv: "Peace I leave with you; my peace I give unto you: not as the world giveth, give I unto you. Let not your heart be troubled, neither let it be fearful.", niv: "Peace I leave with you; my peace I give you. I do not give to you as the world gives. Do not let your hearts be troubled and do not be afraid." },
      { ref: "Isaiah 26:3", kjv: "Thou wilt keep him in perfect peace, whose mind is stayed on thee: because he trusteth in thee.", web: "You will keep whoever's mind is steadfast in perfect peace, because he trusts in you.", asv: "Thou wilt keep him in perfect peace, whose mind is stayed on thee; because he trusteth in thee.", niv: "You will keep in perfect peace him whose mind is steadfast, because he trusts in you." },
      { ref: "Philippians 4:6", kjv: "Be careful for nothing; but in every thing by prayer and supplication with thanksgiving let your requests be made known unto God.", web: "In nothing be anxious, but in everything, by prayer and petition with thanksgiving, let your requests be made known to God.", asv: "In nothing be anxious; but in everything by prayer and supplication with thanksgiving let your requests be made known unto God.", niv: "Do not be anxious about anything, but in everything, by prayer and petition, with thanksgiving, present your requests to God." },
      { ref: "John 16:33", kjv: "These things I have spoken unto you, that in me ye might have peace. In the world ye shall have tribulation: but be of good cheer; I have overcome the world.", web: "I have told you these things, that in me you may have peace. In the world you have oppression; but cheer up! I have overcome the world.", asv: "These things have I spoken unto you, that in me ye may have peace. In the world ye have tribulation: but be of good cheer; I have overcome the world.", niv: "I have told you these things, so that in me you may have peace. In this world you will have trouble. But take heart! I have overcome the world." },
      { ref: "Numbers 6:26", kjv: "The LORD lift up his countenance upon thee, and give thee peace.", web: "Yahweh lift up his face toward you, and give you peace.", asv: "Jehovah lift up his countenance upon thee, and give thee peace.", niv: "The LORD turn his face toward you and give you peace." }
    ]},
    "Gratitude": { desc: "for counting blessings", verses: [
      { ref: "1 Thessalonians 5:18", kjv: "In every thing give thanks: for this is the will of God in Christ Jesus concerning you.", web: "In everything give thanks, for this is the will of God in Christ Jesus toward you.", asv: "In everything give thanks: for this is the will of God in Christ Jesus to you-ward.", niv: "Give thanks in all circumstances, for this is God's will for you in Christ Jesus." },
      { ref: "Psalm 100:4", kjv: "Enter into his gates with thanksgiving, and into his courts with praise: be thankful unto him, and bless his name.", web: "Enter into his gates with thanksgiving, into his courts with praise. Give thanks to him, and bless his name.", asv: "Enter into his gates with thanksgiving, and into his courts with praise: give thanks unto him, and bless his name.", niv: "Enter his gates with thanksgiving and his courts with praise; give thanks to him and praise his name." },
      { ref: "Psalm 107:1", kjv: "O give thanks unto the LORD, for he is good: for his mercy endureth for ever.", web: "Give thanks to Yahweh, for he is good, for his loving kindness endures forever.", asv: "Oh give thanks unto Jehovah; for he is good; for his lovingkindness endureth for ever.", niv: "Give thanks to the LORD, for he is good; his love endures forever." },
      { ref: "Colossians 3:15", kjv: "And let the peace of God rule in your hearts, to the which also ye are called in one body; and be ye thankful.", web: "And let the peace of God rule in your hearts, to which also you were called in one body, and be thankful.", asv: "And let the peace of Christ rule in your hearts, to the which also ye were called in one body; and be ye thankful.", niv: "Let the peace of Christ rule in your hearts, since as members of one body you were called to peace. And be thankful." },
      { ref: "Psalm 118:24", kjv: "This is the day which the LORD hath made; we will rejoice and be glad in it.", web: "This is the day that Yahweh has made. We will rejoice and be glad in it.", asv: "This is the day which Jehovah hath made; we will rejoice and be glad in it.", niv: "This is the day the LORD has made; let us rejoice and be glad in it." },
      { ref: "1 Chronicles 16:34", kjv: "O give thanks unto the LORD; for he is good; for his mercy endureth for ever.", web: "Oh give thanks to Yahweh, for he is good, for his loving kindness endures forever.", asv: "Oh give thanks unto Jehovah; for he is good; for his lovingkindness endureth for ever.", niv: "Give thanks to the LORD, for he is good; his love endures forever." }
    ]},
    "Love": { desc: "for weddings and vows", verses: [
      { ref: "1 Corinthians 13:4", kjv: "Charity suffereth long, and is kind; charity envieth not; charity vaunteth not itself, is not puffed up.", web: "Love is patient and is kind; love doesn't envy. Love doesn't brag, is not proud,", asv: "Love suffereth long, and is kind; love envieth not; love vaunteth not itself, is not puffed up,", niv: "Love is patient, love is kind. It does not envy, it does not boast, it is not proud." },
      { ref: "1 John 4:19", kjv: "We love him, because he first loved us.", web: "We love him, because he first loved us.", asv: "We love, because he first loved us.", niv: "We love because he first loved us." },
      { ref: "John 15:13", kjv: "Greater love hath no man than this, that a man lay down his life for his friends.", web: "Greater love has no one than this, that someone lay down his life for his friends.", asv: "Greater love hath no man than this, that a man lay down his life for his friends.", niv: "Greater love has no one than this, that he lay down his life for his friends." },
      { ref: "1 John 4:16", kjv: "And we have known and believed the love that God hath to us. God is love; and he that dwelleth in love dwelleth in God, and God in him.", web: "We know and have believed the love which God has for us. God is love, and he who remains in love remains in God, and God remains in him.", asv: "And we know and have believed the love which God hath in us. God is love; and he that abideth in love abideth in God, and God abideth in him.", niv: "And so we know and rely on the love God has for us. God is love. Whoever lives in love lives in God, and God in him." },
      { ref: "Song of Solomon 6:3", kjv: "I am my beloved's, and my beloved is mine: he feedeth among the lilies.", web: "I am my beloved's, and my beloved is mine. He browses among the lilies.", asv: "I am my beloved's, and my beloved is mine; he feedeth his flock among the lilies.", niv: "I am my lover's and my lover is mine; he browses among the lilies." },
      { ref: "1 Corinthians 13:13", kjv: "And now abideth faith, hope, charity, these three; but the greatest of these is charity.", web: "But now faith, hope, and love remain, these three. The greatest of these is love.", asv: "But now abideth faith, hope, love, these three; and the greatest of these is love.", niv: "And now these three remain: faith, hope and love. But the greatest of these is love." }
    ]},
    "Courage": { desc: "for facing fear", verses: [
      { ref: "1 Corinthians 16:13", kjv: "Watch ye, stand fast in the faith, quit you like men, be strong.", web: "Watch! Stand firm in the faith! Be courageous! Be strong!", asv: "Watch ye, stand fast in the faith, quit you like men, be strong.", niv: "Be on your guard; stand firm in the faith; be men of courage; be strong." },
      { ref: "Psalm 27:14", kjv: "Wait on the LORD: be of good courage, and he shall strengthen thine heart: wait, I say, on the LORD.", web: "Wait for Yahweh. Be strong, and let your heart take courage. Yes, wait for Yahweh.", asv: "Wait for Jehovah: be strong, and let thy heart take courage; yea, wait thou for Jehovah.", niv: "Wait for the LORD; be strong and take heart and wait for the LORD." },
      { ref: "Joshua 1:7", kjv: "Only be thou strong and very courageous, that thou mayest observe to do according to all the law, which Moses my servant commanded thee: turn not from it to the right hand or to the left, that thou mayest prosper whithersoever thou goest.", web: "Only be strong and very courageous. Be careful to observe to do according to all the law, which Moses my servant commanded you. Don't turn from it to the right hand or to the left, that you may have good success wherever you go.", asv: "Only be strong and very courageous, to observe to do according to all the law, which Moses my servant commanded thee: turn not from it to the right hand or to the left, that thou mayest have good success whithersoever thou goest.", niv: "Be strong and very courageous. Be careful to obey all the law my servant Moses gave you; do not turn from it to the right or to the left, that you may be successful wherever you go." },
      { ref: "2 Timothy 1:7", kjv: "For God hath not given us the spirit of fear; but of power, and of love, and of a sound mind.", web: "For God didn't give us a spirit of fear, but of power, love, and self-control.", asv: "For God gave us not a spirit of fearfulness; but of power and love and discipline.", niv: "For God did not give us a spirit of timidity, but a spirit of power, of love and of self-discipline." },
      { ref: "Psalm 31:24", kjv: "Be of good courage, and he shall strengthen your heart, all ye that hope in the LORD.", web: "Be strong, and let your heart take courage, all you who hope in Yahweh.", asv: "Be strong, and let your heart take courage, all ye that hope in Jehovah.", niv: "Be strong and take heart, all you who hope in the LORD." },
      { ref: "Isaiah 41:10", kjv: "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness.", web: "Don't you be afraid, for I am with you. Don't be dismayed, for I am your God. I will strengthen you. Yes, I will help you. Yes, I will uphold you with the right hand of my righteousness.", asv: "Fear thou not, for I am with thee; be not dismayed, for I am thy God; I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness.", niv: "So do not fear, for I am with you; do not be dismayed, for I am your God. I will strengthen you and help you; I will uphold you with my righteous right hand." }
    ]},
    "New Beginnings": { desc: "for fresh starts", verses: [
      { ref: "2 Corinthians 5:17", kjv: "Therefore if any man be in Christ, he is a new creature: old things are passed away; behold, all things are become new.", web: "Therefore if anyone is in Christ, he is a new creation. The old things have passed away. Behold, all things have become new.", asv: "Wherefore if any man is in Christ, he is a new creature: the old things are passed away; behold, they are become new.", niv: "Therefore, if anyone is in Christ, he is a new creation; the old has gone, the new has come!" },
      { ref: "Isaiah 43:19", kjv: "Behold, I will do a new thing; now it shall spring forth; shall ye not know it? I will even make a way in the wilderness, and rivers in the desert.", web: "Behold, I will do a new thing. It springs out now. Don't you know it? I will even make a way in the wilderness, and rivers in the desert.", asv: "Behold, I will do a new thing; now shall it spring forth; shall ye not know it? I will even make a way in the wilderness, and rivers in the desert.", niv: "See, I am doing a new thing! Now it springs up; do you not perceive it? I am making a way in the desert and streams in the wasteland." },
      { ref: "Lamentations 3:22", kjv: "It is of the LORD's mercies that we are not consumed, because his compassions fail not.", web: "It is because of Yahweh's loving kindnesses that we are not consumed, because his compassion doesn't fail.", asv: "It is of Jehovah's lovingkindnesses that we are not consumed, because his compassions fail not.", niv: "Because of the LORD’s great love we are not consumed, for his compassions never fail." },
      { ref: "Philippians 1:6", kjv: "Being confident of this very thing, that he which hath begun a good work in you will perform it until the day of Jesus Christ.", web: "being confident of this very thing, that he who began a good work in you will complete it until the day of Jesus Christ.", asv: "being confident of this very thing, that he who began a good work in you will perfect it until the day of Jesus Christ.", niv: "Being confident of this, that he who began a good work in you will carry it on to completion until the day of Christ Jesus." },
      { ref: "Revelation 21:5", kjv: "And he that sat upon the throne said, Behold, I make all things new.", web: "He who sits on the throne said, 'Behold, I am making all things new.'", asv: "And he that sitteth on the throne said, Behold, I make all things new.", niv: "He who was seated on the throne said, \"I am making everything new!\"" },
      { ref: "Ezekiel 36:26", kjv: "A new heart also will I give you, and a new spirit will I put within you: and I will take away the stony heart out of your flesh, and I will give you an heart of flesh.", web: "I will also give you a new heart, and I will put a new spirit within you. I will take away the stony heart out of your flesh, and I will give you a heart of flesh.", asv: "A new heart also will I give you, and a new spirit will I put within you; and I will take away the stony heart out of your flesh, and I will give you a heart of flesh.", niv: "I will give you a new heart and put a new spirit in you; I will remove from you your heart of stone and give you a heart of flesh." }
    ]},
    "Faith": { desc: "for trusting the process", verses: [
      { ref: "John 3:16", kjv: "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life.", web: "For God so loved the world, that he gave his one and only Son, that whoever believes in him should not perish, but have eternal life.", asv: "For God so loved the world, that he gave his only begotten Son, that whosoever believeth on him should not perish, but have eternal life.", niv: "For God so loved the world that he gave his one and only Son, that whoever believes in him shall not perish but have eternal life." },
      { ref: "2 Corinthians 5:7", kjv: "For we walk by faith, not by sight.", web: "for we walk by faith, not by sight.", asv: "for we walk by faith, not by sight;", niv: "We live by faith, not by sight." },
      { ref: "Matthew 17:20", kjv: "For verily I say unto you, If ye have faith as a grain of mustard seed, ye shall say unto this mountain, Remove hence to yonder place; and it shall remove; and nothing shall be impossible unto you.", web: "For most certainly I tell you, if you have faith as a grain of mustard seed, you will tell this mountain, 'Move from here to there,' and it will move; and nothing will be impossible for you.", asv: "For verily I say unto you, If ye have faith as a grain of mustard seed, ye shall say unto this mountain, Remove hence to yonder place; and it shall remove; and nothing shall be impossible unto you.", niv: "I tell you the truth, if you have faith as small as a mustard seed, you can say to this mountain, 'Move from here to there' and it will move. Nothing will be impossible for you." },
      { ref: "Romans 10:17", kjv: "So then faith cometh by hearing, and hearing by the word of God.", web: "So faith comes by hearing, and hearing by the word of God.", asv: "So belief cometh of hearing, and hearing by the word of Christ.", niv: "Consequently, faith comes from hearing the message, and the message is heard through the word of Christ." },
      { ref: "Matthew 6:33", kjv: "But seek ye first the kingdom of God, and his righteousness; and all these things shall be added unto you.", web: "But seek first God's Kingdom, and his righteousness; and all these things will be given to you as well.", asv: "But seek ye first his kingdom, and his righteousness; and all these things shall be added unto you.", niv: "But seek first his kingdom and his righteousness, and all these things will be given to you as well." },
      { ref: "Hebrews 11:6", kjv: "But without faith it is impossible to please him: for he that cometh to God must believe that he is, and that he is a rewarder of them that diligently seek him.", web: "Without faith it is impossible to be well pleasing to him, for he who comes to God must believe that he exists, and that he is a rewarder of those who seek him.", asv: "And without faith it is impossible to be well-pleasing unto him; for he that cometh to God must believe that he is, and that he is a rewarder of them that seek after him.", niv: "And without faith it is impossible to please God, because anyone who comes to him must believe that he exists and that he rewards those who earnestly seek him." }
    ]}
  };

  /**
   * A short, hand-picked list of widely-recognized verses — the default
   * landing tab (see `mode` below), since most customers arrive without
   * a specific reference in mind. Most of this text is deliberately
   * reused verbatim from THEMES above (verified/already-transcribed,
   * so there's no new transcription risk on something that ends up
   * printed); the few not already in THEMES (John 1:1, Psalm 46:10)
   * were pulled fresh from bible-api.com, the same source the manual
   * picker itself uses, and hand-cleaned of that endpoint's stray
   * line-breaks/smart-quotes to match this file's plain-text style.
   */
  var POPULAR_VERSES = [
    // Catholic books: exist in the Douay-Rheims only, so these cards show only while it is chosen.
    { ref: "Wisdom 3:1", dra: "But the souls of the just are in the hand of God, and the torment of death shall not touch them." },
    { ref: "1 Maccabees 3:19", dra: "For the success of war is not in the multitude of the army, but strength cometh from heaven." },
    { ref: "John 3:16", kjv: "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life.", web: "For God so loved the world, that he gave his one and only Son, that whoever believes in him should not perish, but have eternal life.", asv: "For God so loved the world, that he gave his only begotten Son, that whosoever believeth on him should not perish, but have eternal life.", niv: "For God so loved the world that he gave his one and only Son, that whoever believes in him shall not perish but have eternal life.", dra: "For God so loved the world, as to give his only begotten Son; that whosoever believeth in him, may not perish, but may have life everlasting." },
    { ref: "John 1:1", kjv: "In the beginning was the Word, and the Word was with God, and the Word was God.", web: "In the beginning was the Word, and the Word was with God, and the Word was God.", asv: "In the beginning was the Word, and the Word was with God, and the Word was God.", niv: "In the beginning was the Word, and the Word was with God, and the Word was God.", dra: "In the beginning was the Word, and the Word was with God, and the Word was God." },
    { ref: "Romans 1:16", kjv: "For I am not ashamed of the gospel of Christ.", web: "For I am not ashamed of the Good News of Christ.", asv: "For I am not ashamed of the gospel.", niv: "I am not ashamed of the gospel.", dra: "For I am not ashamed of the gospel." },
    { ref: "Ephesians 6:11", kjv: "Put on the whole armour of God, that ye may be able to stand against the wiles of the devil.", web: "Put on the whole armor of God, that you may be able to stand against the wiles of the devil.", asv: "Put on the whole armor of God, that ye may be able to stand against the wiles of the devil.", niv: "Put on the full armor of God so that you can take your stand against the devil's schemes.", dra: "Put you on the armour of God, that you may be able to stand against the deceits of the devil." },
    { ref: "Ephesians 6:13", kjv: "Wherefore take unto you the whole armour of God, that ye may be able to withstand in the evil day, and having done all, to stand.", web: "Therefore put on the whole armor of God, that you may be able to withstand in the evil day, and, having done all, to stand.", asv: "Wherefore take up the whole armor of God, that ye may be able to withstand in the evil day, and, having done all, to stand.", niv: "Therefore put on the full armor of God, so that when the day of evil comes, you may be able to stand your ground, and after you have done everything, to stand.", dra: "Therefore, take unto you the armour of God, that you may be able to resist in the evil day and to stand in all things perfect." },
    { ref: "Philippians 4:13", kjv: "I can do all things through Christ which strengtheneth me.", web: "I can do all things through Christ, who strengthens me.", asv: "I can do all things in him that strengtheneth me.", niv: "I can do everything through him who gives me strength.", dra: "I can do all these things in him who strengtheneth me." },
    { ref: "Psalm 23:1", kjv: "The LORD is my shepherd; I shall not want.", web: "Yahweh is my shepherd: I shall lack nothing.", asv: "Jehovah is my shepherd; I shall not want.", niv: "The LORD is my shepherd, I shall not be in want.", dra: "The Lord ruleth me: and I shall want nothing.", ref_dra: "Psalm 22:1" },
    { ref: "Jeremiah 29:11", kjv: "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end.", web: "For I know the thoughts that I think toward you, says Yahweh, thoughts of peace, and not of evil, to give you hope and a future.", asv: "For I know the thoughts that I think toward you, saith Jehovah, thoughts of peace, and not of evil, to give you hope in your latter end.", niv: "For I know the plans I have for you, declares the LORD, plans to prosper you and not to harm you, plans to give you hope and a future.", dra: "For I know the thoughts that I think towards you, saith the Lord, thoughts of peace, and not of affliction, to give you an end and patience." },
    { ref: "Proverbs 3:5-6", kjv: "Trust in the LORD with all thine heart; and lean not unto thine own understanding. In all thy ways acknowledge him, and he shall direct thy paths.", web: "Trust in Yahweh with all your heart, and don't lean on your own understanding. In all your ways acknowledge him, and he will make your paths straight.", asv: "Trust in Jehovah with all thy heart, and lean not upon thine own understanding. In all thy ways acknowledge him, and he will direct thy paths.", niv: "Trust in the LORD with all your heart and lean not on your own understanding; in all your ways acknowledge him, and he will make your paths straight.", dra: "Have confidence in the Lord with all thy heart, and lean not upon thy own prudence. In all thy ways think on him, and he will direct thy steps." },
    { ref: "Romans 8:28", kjv: "And we know that all things work together for good to them that love God, to them who are the called according to his purpose.", web: "We know that all things work together for good for those who love God, to those who are called according to his purpose.", asv: "And we know that to them that love God all things work together for good, even to them that are called according to his purpose.", niv: "And we know that in all things God works for the good of those who love him, who have been called according to his purpose.", dra: "And we know that to them that love God, all things work together unto good, to such as, according to his purpose, are called to be saints." },
    { ref: "Joshua 1:9", kjv: "Have not I commanded thee? Be strong and of a good courage; be not afraid, neither be thou dismayed: for the LORD thy God is with thee whithersoever thou goest.", web: "Haven't I commanded you? Be strong and courageous. Don't be afraid. Don't be dismayed, for Yahweh your God is with you wherever you go.", asv: "Have not I commanded thee? Be strong and of good courage; be not affrighted, neither be thou dismayed: for Jehovah thy God is with thee whithersoever thou goest.", niv: "Have I not commanded you? Be strong and courageous. Do not be terrified; do not be discouraged, for the LORD your God will be with you wherever you go.", dra: "Behold I command thee, take courage, and be strong. Fear not and be not dismayed: because the Lord thy God is with thee in all things whatsoever thou shalt go to." },
    { ref: "Isaiah 6:8", kjv: "Also I heard the voice of the Lord, saying, Whom shall I send, and who will go for us? Then said I, Here am I; send me.", web: "I heard the Lord's voice, saying, \"Whom shall I send, and who will go for us?\" Then I said, \"Here I am. Send me!\"", asv: "And I heard the voice of the Lord, saying, Whom shall I send, and who will go for us? Then I said, Here am I; send me.", niv: "Then I heard the voice of the Lord saying, \"Whom shall I send? And who will go for us?\" And I said, \"Here am I. Send me!\"", dra: "And I heard the voice of the Lord, saying: Whom shall I send? and who shall go for us? And I said: Lo, here am I, send me." },
    { ref: "Isaiah 41:10", kjv: "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness.", web: "Don't you be afraid, for I am with you. Don't be dismayed, for I am your God. I will strengthen you. Yes, I will help you. Yes, I will uphold you with the right hand of my righteousness.", asv: "Fear thou not, for I am with thee; be not dismayed, for I am thy God; I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness.", niv: "So do not fear, for I am with you; do not be dismayed, for I am your God. I will strengthen you and help you; I will uphold you with my righteous right hand.", dra: "Fear not, for I am with thee: turn not aside, for I am thy God: I have strengthened thee, and have helped thee, and the right hand of my just one hath upheld thee." },
    { ref: "2 Corinthians 5:17", kjv: "Therefore if any man be in Christ, he is a new creature: old things are passed away; behold, all things are become new.", web: "Therefore if anyone is in Christ, he is a new creation. The old things have passed away. Behold, all things have become new.", asv: "Wherefore if any man is in Christ, he is a new creature: the old things are passed away; behold, they are become new.", niv: "Therefore, if anyone is in Christ, he is a new creation; the old has gone, the new has come!", dra: "If then any be in Christ a new creature, the old things are passed away, behold all things are made new." },
    { ref: "Psalm 46:10", kjv: "Be still, and know that I am God: I will be exalted among the heathen, I will be exalted in the earth.", web: "Be still, and know that I am God. I will be exalted among the nations. I will be exalted in the earth.", asv: "Be still, and know that I am God: I will be exalted among the nations, I will be exalted in the earth.", niv: "Be still, and know that I am God; I will be exalted among the nations, I will be exalted in the earth.", dra: "Be still and see that I am God; I will be exalted among the nations, and I will be exalted in the earth.", ref_dra: "Psalm 45:11" },
    { ref: "1 John 4:19", kjv: "We love him, because he first loved us.", web: "We love him, because he first loved us.", asv: "We love, because he first loved us.", niv: "We love because he first loved us.", dra: "Let us therefore love God, because God first hath loved us." }
  ];

  /**
   * Real (canvas-measured, pixel-accurate) word-wrap — mirrors
   * balancedWrapLines in worker/src/render.js exactly (same DP-based
   * least-raggedness algorithm), using a hidden <canvas> 2D context's
   * measureText instead of opentype.js since there's no font file to
   * parse directly in the browser. Replaces the old fixed-character-
   * count wrapToCharLimit (a poor proxy for rendered width in a
   * non-monospace font, and — worse — a plain greedy wrap on TOP of
   * that estimate could still leave a short orphaned last line even
   * when the character-count guess was otherwise fine; see the doc
   * comment on balancedWrapLines in render.js for a real example).
   *
   * measureFont must be a canvas `font` string (e.g. "32px Cardo,
   * serif") at the EXACT size text will actually render at — the DP
   * below only gives balanced results if the widths it measures match
   * the real rendered widths, so this always runs at the verse's own
   * natural font size (computed from the container's width, same as
   * before), never a placeholder.
   */
  var measureCanvas = document.createElement("canvas");
  var measureCtx = measureCanvas.getContext("2d");
  function textWidth(font, s) {
    measureCtx.font = font;
    return measureCtx.measureText(s).width;
  }

  function greedyWrapLines(font, words, maxWidthPx) {
    var lines = [];
    var current = "";
    for (var i = 0; i < words.length; i++) {
      var word = words[i];
      var candidate = current ? current + " " + word : word;
      if (current && textWidth(font, candidate) > maxWidthPx) {
        lines.push(current);
        current = word;
      } else {
        current = candidate;
      }
    }
    if (current) lines.push(current);
    return lines;
  }

  function balancedWrapLines(font, text, maxWidthPx) {
    var words = text.split(/\s+/).filter(Boolean);
    var n = words.length;
    if (n === 0) return [];

    var targetLineCount = greedyWrapLines(font, words, maxWidthPx).length;
    if (targetLineCount <= 1) return [words.join(" ")];

    var spaceWidth = textWidth(font, " ");
    var wordWidthPrefix = [0];
    var i;
    for (i = 0; i < n; i++) wordWidthPrefix.push(wordWidthPrefix[i] + textWidth(font, words[i]));
    function lineWidth(i, j) {
      return wordWidthPrefix[j] - wordWidthPrefix[i] + Math.max(0, j - i - 1) * spaceWidth;
    }

    var INF = Infinity;
    var dp = [];
    var brk = [];
    var c, j;
    for (c = 0; c <= targetLineCount; c++) {
      dp.push(new Array(n + 1).fill(INF));
      brk.push(new Array(n + 1).fill(-1));
    }
    dp[0][0] = 0;
    for (c = 1; c <= targetLineCount; c++) {
      for (j = 1; j <= n; j++) {
        // i counts DOWN from j-1 toward c-1 so lineWidth(i, j) only ever
        // grows as the loop proceeds (see the matching comment in
        // render.js's balancedWrapLines for why counting up instead
        // breaks the search before it ever reaches a valid split).
        for (i = j - 1; i >= c - 1; i--) {
          if (dp[c - 1][i] === INF) continue;
          var w = lineWidth(i, j);
          if (w > maxWidthPx) break;
          var slack = maxWidthPx - w;
          var cost = dp[c - 1][i] + slack * slack;
          if (cost < dp[c][j]) {
            dp[c][j] = cost;
            brk[c][j] = i;
          }
        }
      }
    }

    var lines = [];
    j = n;
    for (c = targetLineCount; c >= 1; c--) {
      i = brk[c][j];
      lines.unshift(words.slice(i, j).join(" "));
      j = i;
    }
    return lines;
  }

  /**
   * One fixed composition, not a per-line-count bucket table — mirrors
   * VERSE_PRESET in worker/src/render.js exactly, so the live preview
   * and the actual print agree. Replaces the old LINE_PRESETS (2026-09
   * verse-print-tuner artifact), which gave short and long verses
   * genuinely different looks (different refRatio, different
   * verseAlign) instead of the same design at a different size.
   * Re-measured (2026-09-18) directly against the user's real approved
   * reference mockups — see the matching doc comment on VERSE_PRESET in
   * render.js for how (a local trace-overlay tool against the actual
   * mockup photos, not eyeballed): refRatio 0.4 (was 0.292), lineHeight
   * 1.7 (was 1.0). containerRatio (the verse's natural size as a
   * fraction of the print-area box's own width) is unchanged — a
   * separate "how big overall" lever from the ratio/spacing fix here.
   * Every verse length uses this SAME refRatio/containerRatio/lineHeight
   * and is fit by uniformly scaling the whole ref+verse block (see
   * fitVerse below) rather than swapping to a different ratio at 3+
   * lines — so a longer verse looks exactly like the reference mockups,
   * just uniformly smaller.
   *
   * Alignment is the one exception, and is deliberately NOT in this
   * preset — see alignForLineCount below, right where the final line
   * count is known.
   *
   * containerRatio fixed 2026-09-23 (was 0.129, over double what it
   * should be): that value predates render.js's current small-box
   * design and was never resynced when it landed. The server has no
   * ratio at all — it applies a fixed SMALL_BOX_MAX_FONT_SIZE (78) to
   * BACK_PRINT_BOX regardless of the box's own pixel size — so the
   * equivalent ratio is 78/1307 (the Tee box width) ≈ 0.06, not 0.129.
   * At 0.129 the preview started every verse at roughly double the
   * font size render.js does, so anything longer than a couple of
   * lines needed far more downscaling than the server ever needs,
   * hitting MIN_SCALE while still overflowing — caught live: Joshua 1:8
   * rendered as 6 lines at 8px with a "too long to print" warning in
   * the preview, while the real print file (render.js, unaffected by
   * this constant) renders the same verse as a clean 3 lines.
   */
  var VERSE_PRESET = { refRatio: 0.6, containerRatio: 0.06, lineHeight: 1.7 };

  /*
   * Reworked 2026-10-07 together with worker/src/render.js (see the
   * VERSE_PRESET doc comment there for the why): biggest size that fits,
   * a larger reference with a floor, a cap on how much of the box the
   * block may fill, and leading that tightens with line count. Every
   * constant below mirrors render.js exactly — change them together or
   * the preview stops matching the print.
   */
  var REF_MIN_FRACTION = 0.34;     // reference font >= this x the max verse size
  var MAX_BLOCK_FRACTION = 0.6;    // block may fill at most this much of the box height
  var SIZE_TRADE_TOLERANCE = 0.1;  // fewer lines only if they cost < 10% size
  var MIN_SCALE = 0.45;
  var REF_GAP_RATIO = 20 / 78;     // gap under the reference / max verse size (render.js marginBottom 20 @ 78)

  function leadingForLines(n) {
    return n <= 2 ? 1.7 : Math.max(1.42, 1.7 - 0.09 * (n - 2));
  }

  // The print font has no straight apostrophe (it prints as an empty box);
  // render.js swaps in the typographic one, so do the same here.
  function fixApostrophes(text) {
    return String(text).replace(/'/g, "’");
  }

  /*
   * The print font draws ":" as two tiny dots in a very tight space, and its narrow "1" looks like a lowercase l, so a
   * reference such as "Psalms 23:1-6" read as "Psalms 231-6". The colon is drawn larger with room either side, and "-"
   * becomes an en dash with room either side. Mirrors referenceChildren() in worker/src/render.js (same scale, margin and
   * drop numbers, written here in the span's own em) and the .vc-ref-colon / .vc-ref-dash rules in verse-customizer.css.
   */
  function spaceReference(text) {
    var parts = String(text).split(/([:\-–])/);
    var out = "";
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      if (p === "") continue;
      if (p === ":") out += '<span class="vc-ref-colon">:</span>';
      else if (p === "-" || p === "–") out += '<span class="vc-ref-dash">–</span>';
      else out += p.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }
    return out;
  }

  /**
   * Always centered (2026-10-06, explicit request) — previously 3+ lines
   * switched to left-aligned, which meant customers saw two different
   * layouts depending on verse length. Mirrors render.js's own
   * alignForLineCount exactly; keep the two in sync. Applies to both the
   * reference line and the verse body together.
   */
  function alignForLineCount() {
    return "center";
  }

  // (Legacy, pre-JS fallback only) matches .vc-print-ref's margin-bottom: 0.25em in verse-customizer.css
  // — kept in sync by hand (same pattern as VERSE_PRESET itself, mirrored
  // against render.js) since fitVerse below needs to predict that gap in
  // px before the ref element exists in the DOM to measure it from.
  var REF_MARGIN_BOTTOM_EM = 0.25;

  /**
   * The verse's natural/default font size at scale 1 — a fraction of the
   * CONTAINER's own current width, not a flat constant, so the whole
   * block scales together whenever the container itself resizes (mobile
   * bottom sheet vs. desktop side panel).
   */
  function naturalVerseFontPx(container) {
    var px = Math.round(container.clientWidth * VERSE_PRESET.containerRatio);
    // Container still mid-layout (0/near-0 width, e.g. right after a
    // panel opens before its transition settles) — fall back to the old
    // fixed default rather than shrinking the text to nothing.
    if (!px || px < 10) px = 24;
    return px;
  }

  /**
   * Finds the composition scale (see VERSE_PRESET) that makes the verse
   * fit the box — mirrors renderVerseArt's own scale search in
   * worker/src/render.js exactly, so the live preview and the real print
   * agree. Searches EVERY candidate scale from 1 down to MIN_SCALE, and
   * at each one re-wraps the verse (a cheap line-count-only greedy wrap)
   * against the box's own FIXED pixel width using THAT candidate's
   * shrunk font size, keeping whichever fitting candidate has the fewest
   * wrapped lines (ties toward the largest scale) rather than just the
   * first one that fits — see the loop's own comment below for why.
   *
   * This replaced an earlier version that wrapped once at the natural
   * (scale-1) font size and then shrank the whole rendered block with a
   * single CSS transform: scale(). That looked right for a short verse,
   * but for a longer one it kept whatever line breaks the natural size
   * produced (many short lines, since the font size never adapted before
   * wrapping) and then visually shrank that already-narrow block —
   * leaving a tall, narrow column of short lines in the middle of the
   * print area instead of using its width, unlike the real printed
   * output (render.js never had this bug: it always re-wraps at each
   * candidate font size against the fixed box width, so a smaller font
   * naturally produces fewer, WIDER lines that actually fill the box).
   */
  function fitVerse(container, verseText) {
    verseText = fixApostrophes(verseText);
    var fontFamily = getComputedStyle(container).fontFamily;
    // Fit in a fixed VIRTUAL box (same aspect ratio as the real on-screen
    // box), then scale the result to the actual displayed size — fixed
    // 2026-10-06. Fitting against the real on-screen pixel size meant the
    // result depended on screen width: on a phone the box is only ~125x47
    // px, where whole-pixel font rounding and the ABSOLUTE_MIN_PX floor
    // made EVERY verse fail the height check ("Too long to print well"),
    // while the same verse fit fine on desktop. Fitting in virtual units
    // (like render.js does against its real 1307px-wide box) gives the
    // same line breaks and same fits/doesn't-fit answer at every screen
    // size; only the final font sizes are scaled down for display.
    var VIRTUAL_WIDTH = 1000;
    var displayWidth = container.clientWidth;
    var factor = displayWidth > 0 ? displayWidth / VIRTUAL_WIDTH : 1;
    var maxWidthPx = displayWidth > 0 ? VIRTUAL_WIDTH : displayWidth;
    // Small safety margin so text stops shrinking a touch before it's
    // flush against the (invisible) print-area edge, not exactly at it
    // — otherwise descenders/the last line can look right on the verge
    // of being clipped even when technically still inside the box.
    // (24 virtual px ~= the old 6 displayed px on a ~210px-wide desktop box.)
    var BOTTOM_SAFETY_MARGIN = displayWidth > 0 ? 24 : 6;
    var boxHeight = container.clientHeight / factor;
    var availableHeight = Math.min(boxHeight - BOTTOM_SAFETY_MARGIN, boxHeight * MAX_BLOCK_FRACTION);
    var naturalPx = displayWidth > 0 ? Math.round(VIRTUAL_WIDTH * VERSE_PRESET.containerRatio) : naturalVerseFontPx(container);
    var naturalRefPx = Math.round(naturalPx * VERSE_PRESET.refRatio);
    var refFloorPx = Math.round(naturalPx * REF_MIN_FRACTION);
    var gapAtNatural = naturalPx * REF_GAP_RATIO;
    var words = verseText.split(/\s+/).filter(Boolean);

    function sizesAt(scale) {
      return {
        versePx: Math.max(1, Math.round(naturalPx * scale)),
        refPx: Math.max(1, refFloorPx, Math.round(naturalRefPx * scale)),
        gapPx: gapAtNatural * scale,
      };
    }
    function lineCountAtScale(scale) {
      var font = sizesAt(scale).versePx + "px " + fontFamily;
      return greedyWrapLines(font, words, maxWidthPx).length;
    }
    function totalHeightAtScale(scale, lineCount) {
      var s = sizesAt(scale);
      return s.refPx * VERSE_PRESET.lineHeight + s.gapPx + lineCount * s.versePx * leadingForLines(lineCount);
    }

    // Hard floor in real on-screen px: below ABSOLUTE_MIN_PX a candidate
    // isn't a layout, it's just illegible (see the history of this
    // constant: tiny preview boxes used to fail every verse).
    var ABSOLUTE_MIN_PX = 9;
    // Clamped to at most 1 so a too-small container falls back to the
    // plain MIN_SCALE search instead of skipping the loop entirely.
    var effectiveMinScale = Math.min(1, Math.max(MIN_SCALE, ABSOLUTE_MIN_PX / naturalPx));

    // Biggest size that fits; a smaller one within SIZE_TRADE_TOLERANCE of
    // it wins only if it needs fewer lines. Mirrors fitVerseLayout in
    // worker/src/render.js exactly.
    var candidates = [];
    var scale = 1;
    while (scale >= effectiveMinScale - 1e-9) {
      var n = lineCountAtScale(scale);
      if (totalHeightAtScale(scale, n) <= availableHeight) candidates.push({ scale: scale, lines: n });
      scale = Math.round((scale - 0.01) * 100) / 100;
    }
    var chosen = effectiveMinScale;
    var overflowing = true;
    if (candidates.length) {
      overflowing = false;
      var biggest = candidates[0].scale;
      var fewest = Infinity;
      candidates.forEach(function (c) {
        if (c.scale >= biggest * (1 - SIZE_TRADE_TOLERANCE) && c.lines < fewest) {
          fewest = c.lines;
          chosen = c.scale;
        }
      });
    }

    var sz = sizesAt(chosen);
    var measureFont = sz.versePx + "px " + fontFamily;
    var lines = balancedWrapLines(measureFont, verseText, maxWidthPx);

    // sizes above are VIRTUAL px — scale to the displayed size (fractional
    // px is fine for CSS font-size; lines were already broken against the
    // virtual width so they scale together).
    return {
      versePx: Math.round(sz.versePx * factor * 100) / 100,
      refPx: Math.round(sz.refPx * factor * 100) / 100,
      gapPx: Math.round(sz.gapPx * factor * 100) / 100,
      lineHeight: leadingForLines(lines.length),
      lines: lines,
      overflowing: overflowing,
    };
  }

  function fetchJson(url) {
    return fetch(url).then(function (res) {
      if (!res.ok) throw new Error("Bible API request failed (" + res.status + ")");
      return res.json();
    });
  }

  function initSection(config) {
    var root = document.getElementById("vc-root-" + config.sectionId);
    if (!root) return;

    var garment = root.dataset.garment;
    var fullVerse = root.dataset.fullVerse === "true";

    var $ = function (sel) { return root.querySelector(sel); };

    var colorSel = $(".vc-color-select");
    var sizeSel = $(".vc-size-select");
    var printSel = $(".vc-print-select");
    var printField = $(".vc-print-field");
    var printPills = $(".vc-print-pills");
    var bookSel = $(".vc-book-select");
    var chapterSel = $(".vc-chapter-select");
    var verseFromSel = $(".vc-verse-from-select");
    var verseToSel = $(".vc-verse-to-select");
    var translationSel = $(".vc-translation-select");
    var translationMysterySel = $(".vc-translation-mystery-select");
    var themeGrid = $(".vc-theme-grid");
    var rerollBtn = $(".vc-reroll-btn");
    var citation = $(".vc-citation");
    var printText = $(".vc-print-text");
    var fitBadge = $(".vc-fit-badge");
    var garmentSvg = $(".vc-garment-svg");
    var teePhotoBack = $(".vc-tee-photo-back");
    var teePhotoFront = $(".vc-tee-photo-front");
    // Shading feImages live in the page-level <svg><defs> near the top of
    // verse-customizer.liquid (shared, not per-.vc-root), so these are
    // looked up by id rather than through the root-scoped $() helper.
    var shadeImgTee = document.getElementById("vc-shade-img-tee");
    var shadeImgHoodie = document.getElementById("vc-shade-img-hoodie");
    var garmentPath = $(".vc-garment-path");
    var hoodPath = $(".vc-hood-path");
    var pocketPath = $(".vc-pocket-path");
    var colorPills = $(".vc-color-pills");
    var sizePills = $(".vc-size-pills");
    var frontDetails = root.querySelectorAll(".vc-front-detail");
    var ribLines = root.querySelectorAll(".vc-rib-line");
    var capDetails = root.querySelectorAll(".vc-cap-seam, .vc-cap-button, .vc-cap-eyelet");
    var sockRibs = root.querySelectorAll(".vc-sock-rib");
    var frontLogoLayer = $(".vc-front-logo-layer");
    var frontLogoImg = frontLogoLayer.querySelector(".vc-front-logo-img");
    var smallFormatNote = $(".vc-small-format-note");
    var shirtStage = $(".vc-shirt-stage");
    var stageViewport = $(".vc-stage-viewport");
    var zoomInBtn = $(".vc-zoom-in");
    var zoomOutBtn = $(".vc-zoom-out");
    var zoomLevelLabel = $(".vc-zoom-level");
    var viewToggle = $(".vc-view-toggle");
    var viewBtns = root.querySelectorAll(".vc-view-btn");
    var modeTabs = root.querySelectorAll(".vc-mode-tab");
    var popularForm = $(".vc-popular-form");
    var manualForm = $(".vc-manual-form");
    var mysteryForm = $(".vc-mystery-form");
    var addBtn = $(".vc-add-to-cart-btn");
    var atcLabel = $(".vc-atc-label");
    var atcSpinner = $(".vc-atc-spinner");
    var atcError = $(".vc-atc-error");
    var reviewGarmentEl = $('[data-review="garment"]');
    var reviewSizeEl = $('[data-review="size"]');
    var reviewPriceEl = $('[data-review="price"]');
    var reviewVerseTextEl = $('[data-review="verse-text"]');
    var reviewThumbEl = $(".vc-review-thumb");
    var purchaseNoteEl = $("[data-purchase-note]");
    var previewMetaSubEl = $('[data-review="preview-sub"]');

    var stepPanels = root.querySelectorAll("[data-step-panel]");
    var stepNodes = root.querySelectorAll("[data-step-node]");
    var stepNextBtns = root.querySelectorAll("[data-step-next]");
    var stepBackBtns = root.querySelectorAll("[data-step-back]");
    var step2NextBtn = root.querySelector('[data-step-next="3"]');
    var stepIntroEl = root.querySelector("[data-step-intro]");
    // Mirrors clvry-how-it-works.liquid's own per-step description text
    // (same "tell the shopper what to actually do here" job), scaled
    // down to one line since the step itself is right here to look at.
    var STEP_INTROS = {
      1: "Pick the colour, size and print style you want — the preview updates live as you go.",
      2: "Choose a verse from our popular picks, search for a specific one of your own, or let us surprise you by theme.",
      3: "Double-check everything below, then add it to your cart — every piece is made to order, just for you."
    };

    var mode = "popular";
    root.setAttribute("data-vc-mode", mode);
    var currentView = "back";
    var currentTheme = null;
    var lastVerseIndex = -1;
    var selected = { text: null, reference: null, translation: "kjv" };
    var usingRealTeePhoto = false;
    // Set when the page was opened from a cart line's "Edit" link
    // (?vc_edit=<line key>): { key, quantity, variantId, properties } of the line being edited.
    var editLine = null;

    // --- Variants: Color + Size come from the real Shopify product ---
    // config.optionNames is product.options_with_values — an array of
    // { name, values: [{ name, ... }] } — not product.options, which is
    // just an array of name strings with no values attached.

    function valueNames(option) {
      return option.values.map(function (v) { return typeof v === "string" ? v : v.name; });
    }

    var colorValues = [];
    var sizeValues = [];
    var printValues = [];
    var matchedOptions = [];
    config.optionNames.forEach(function (opt) {
      if (/color/i.test(opt.name)) {
        colorValues = valueNames(opt);
        matchedOptions.push(opt);
      } else if (/size/i.test(opt.name)) {
        sizeValues = valueNames(opt);
        matchedOptions.push(opt);
      } else if (/print/i.test(opt.name)) {
        printValues = valueNames(opt);
        matchedOptions.push(opt);
      }
    });
    // Fallback if an option isn't literally named "Color"/"Size" — use
    // position instead, but only among options that regex matching
    // didn't already claim. Without this guard, a single-option product
    // (e.g. Socks, which only has Size and no Color at all) would have
    // its one option treated as BOTH color and size, since "first
    // option" and "the size option" are the same option.
    var unmatched = config.optionNames.filter(function (opt) {
      return matchedOptions.indexOf(opt) === -1;
    });
    if (colorValues.length === 0 && unmatched.length) colorValues = valueNames(unmatched.shift());
    if (sizeValues.length === 0 && unmatched.length) sizeValues = valueNames(unmatched.shift());

    colorValues.forEach(function (c) {
      var opt = document.createElement("option");
      opt.value = c;
      opt.textContent = c;
      colorSel.appendChild(opt);
    });
    sizeValues.forEach(function (s) {
      var opt = document.createElement("option");
      opt.value = s;
      opt.textContent = s;
      sizeSel.appendChild(opt);
    });
    // No size is pre-selected when there is a real choice: personalised items
    // can't be returned for change of mind, so the customer must pick one
    // deliberately (Continue stays disabled until they do). One-size products
    // keep their single value.
    if (sizeValues.length > 1) {
      var sizePlaceholder = document.createElement("option");
      sizePlaceholder.value = "";
      sizePlaceholder.textContent = "Select a size";
      sizeSel.insertBefore(sizePlaceholder, sizeSel.firstChild);
      sizeSel.value = "";
    }
    printValues.forEach(function (p) {
      var opt = document.createElement("option");
      opt.value = p;
      opt.textContent = p;
      printSel.appendChild(opt);
    });
    if (printValues.length) printField.classList.remove("vc-hidden");

    // Native <selects> above stay the source of truth (state + the
    // change events the rest of this file already listens for); these
    // pill buttons are just a themed skin over them, mirroring the
    // swatch-style pickers used on the rest of the site instead of a
    // generic dropdown.
    function buildPillGroup(container, sel, values, swatchFor, subFor) {
      values.forEach(function (v) {
        var pill = document.createElement("button");
        pill.type = "button";
        pill.className = "vc-pill";
        pill.dataset.value = v;
        if (swatchFor) {
          var swatch = document.createElement("span");
          swatch.className = "vc-pill-swatch";
          swatch.style.background = swatchFor(v);
          pill.appendChild(swatch);
        }
        var label = document.createElement("span");
        label.textContent = v;
        label.className = "vc-pill-title";
        pill.appendChild(label);
        var sub = subFor ? subFor(v) : "";
        if (sub) {
          var subEl = document.createElement("span");
          subEl.className = "vc-pill-sub";
          subEl.textContent = sub;
          pill.appendChild(subEl);
          pill.classList.add("vc-pill--with-sub");
        }
        pill.addEventListener("click", function () {
          sel.value = v;
          sel.dispatchEvent(new Event("change"));
        });
        container.appendChild(pill);
      });

      sel.addEventListener("change", function () {
        Array.prototype.forEach.call(container.children, function (p) {
          p.classList.toggle("active", p.dataset.value === sel.value);
        });
      });
    }

    buildPillGroup(colorPills, colorSel, colorValues, function (v) {
      return (COLORS[v] || COLORS.Black).fill;
    });
    buildPillGroup(sizePills, sizeSel, sizeValues, null);
    // One line under each Print option saying what it is and what happens
    // next (Logo Only skips the verse step entirely — see verseRequiredNow()).
    var PRINT_SUBTEXT = {
      "Verse Backprint": "Your chosen verse printed across the back, plus the small CLVRY logo on the chest. Next: pick your verse.",
      "Logo Only": "Just the small CLVRY logo on the chest, no verse. Next: straight to review.",
    };
    if (printValues.length) buildPillGroup(printPills, printSel, printValues, null, function (v) { return PRINT_SUBTEXT[v] || ""; });

    colorSel.dispatchEvent(new Event("change"));
    sizeSel.dispatchEvent(new Event("change"));
    if (printValues.length) printSel.dispatchEvent(new Event("change"));

    // --- Step 1 gate: a size must be chosen before Continue ---
    var step1Next = root.querySelector('[data-step-panel="1"] [data-step-next]');
    var sizeHint = null;
    if (step1Next && sizeValues.length > 1) {
      sizeHint = document.createElement("span");
      sizeHint.className = "vc-size-hint";
      sizeHint.textContent = "Choose a size to continue";
      step1Next.parentNode.insertBefore(sizeHint, step1Next);
    }
    function applyStep1Gate() {
      if (!step1Next || sizeValues.length < 2) return;
      var ready = !!sizeSel.value;
      step1Next.disabled = !ready;
      if (sizeHint) sizeHint.classList.toggle("vc-hidden", ready);
    }
    sizeSel.addEventListener("change", applyStep1Gate);
    applyStep1Gate();

    // --- Price on each Print option (Verse Backprint costs more than Logo Only) ---
    var printPriceEls = {};
    if (printValues.length) {
      Array.prototype.forEach.call(printPills.querySelectorAll(".vc-pill"), function (pill) {
        var priceEl = document.createElement("span");
        priceEl.className = "vc-pill-price";
        var title = pill.querySelector(".vc-pill-title");
        pill.insertBefore(priceEl, title ? title.nextSibling : pill.firstChild);
        pill.classList.add("vc-pill--with-sub");
        printPriceEls[pill.dataset.value] = priceEl;
      });
    }
    function updatePrintPrices() {
      printValues.forEach(function (pv) {
        var el = printPriceEls[pv];
        if (!el) return;
        var v = findVariant(colorSel.value, sizeSel.value || sizeValues[0], pv);
        el.textContent = v ? "£" + (Number(v.price) / 100).toFixed(2) : "";
      });
    }
    colorSel.addEventListener("change", updatePrintPrices);
    sizeSel.addEventListener("change", updatePrintPrices);
    updatePrintPrices();

    // ?color=<Name> (e.g. from the homepage hero's rotating images) opens the
    // page on that colour instead of the first one.
    (function () {
      var want = null;
      try { var sp = new URLSearchParams(window.location.search); want = sp.get("color") || sp.get("colour"); } catch (e) {}
      if (!want) return;
      var match = colorValues.filter(function (c) { return c.toLowerCase() === want.trim().toLowerCase(); })[0];
      if (match) {
        colorSel.value = match;
        colorSel.dispatchEvent(new Event("change"));
      }
    })();

    function findVariant(color, size, print) {
      return config.variants.filter(function (v) {
        return v.option1 === color || v.option2 === color || v.option3 === color;
      }).filter(function (v) {
        return v.option1 === size || v.option2 === size || v.option3 === size;
      }).filter(function (v) {
        // Only products with a real Print option (Tee/Hoodie) pass this —
        // without it, two variants can otherwise share the same color/size
        // (one per Print value) and this would ambiguously return whichever
        // happened to be first.
        return !print || v.option1 === print || v.option2 === print || v.option3 === print;
      })[0];
    }

    function updateGarmentChrome() {
      var color = COLORS[colorSel.value] || COLORS.Black;
      var strokeTone = color.ink === "light" ? "rgba(244,241,233,0.4)" : "rgba(33,29,24,0.35)";

      // Real product photography exists for Tee, Hoodie, and Cap (both
      // of its colors, Black/White) — use it there and fall back to the
      // illustrated SVG for garments/colors that don't have a photo
      // export at all (Socks).
      var PHOTOS_BY_GARMENT = { Tee: window.VC_TEE_PHOTOS, Hoodie: window.VC_HOODIE_PHOTOS, Cap: window.VC_CAP_PHOTOS };
      var garmentPhotos = PHOTOS_BY_GARMENT[garment];
      var teePhotos = garmentPhotos && garmentPhotos[colorSel.value];

      // Tee/Hoodie always use photo mode, even for a color without its
      // own photo yet — falling back to the Black photo + CSS filter
      // (see the branch below). Cap only switches to photo mode for a
      // color that actually has one — every Cap color currently offered
      // (Black/White) does, but this stays conditional rather than a
      // flat garment-name check as a defensive fallback if a color ever
      // gets added without a photo: unlike Tee/Hoodie's black-based
      // fallback, recoloring a white or black cap photo toward an
      // arbitrary other color via CSS filter isn't a reliable trick, so
      // such a color would stay on the illustrated SVG instead of a
      // badly-tinted photo.
      var hasPhoto = garment === "Tee" || garment === "Hoodie" || (garment === "Cap" && !!teePhotos);
      garmentSvg.classList.toggle("vc-hidden", hasPhoto);
      teePhotoBack.classList.toggle("vc-hidden", !hasPhoto);
      teePhotoFront.classList.toggle("vc-hidden", !hasPhoto);

      // Cap's front logo sits at a different spot than Tee/Hoodie's left-
      // chest position (see .vc-logo-cap in verse-customizer.css) — the
      // cap illustration has no chest at all to put it on. Only matters
      // when the SVG is actually showing (usingRealTeePhoto below hides
      // this layer entirely whenever a real photo already has the logo
      // baked in).
      frontLogoLayer.classList.toggle("vc-logo-cap", garment === "Cap");

      // Real per-color photos (window.VC_TEE_PHOTOS / VC_HOODIE_PHOTOS /
      // VC_CAP_PHOTOS, set in the Liquid template) replace the old
      // single-Black-photo + CSS-filter guess for any color that has
      // one. The front shot already has the CLVRY logo baked in at the
      // correct ink, so the separate dynamic .vc-front-logo-layer
      // overlay gets hidden entirely in that case (see usingRealTeePhoto
      // in applyViewState) — showing both would double up the logo.
      // Colors without a real photo yet fall back to the original Black
      // photo + CSS filter approximation (Tee/Hoodie only — see hasPhoto
      // above for why Cap doesn't attempt this).
      usingRealTeePhoto = hasPhoto && !!teePhotos;
      if (hasPhoto) {
        if (teePhotos) {
          teePhotoBack.src = teePhotos.back;
          teePhotoFront.src = teePhotos.front;
          teePhotoBack.style.filter = "none";
          teePhotoFront.style.filter = "none";
        } else {
          teePhotoBack.style.filter = color.photoFilter;
          teePhotoFront.style.filter = color.photoFilter;
        }
      }

      // Keep the back-print shading filter (vc-warp-back-tee/-hoodie —
      // see verse-customizer.liquid) sampling whatever photo is actually
      // on screen, so the fold/shadow detail it picks up always matches
      // the selected color instead of staying fixed on the default. Only
      // Tee/Hoodie have a shading filter at all (see the CSS: Cap/Socks
      // never apply one), and it only makes sense once a real per-color
      // photo exists — the CSS-filter-approximation branch above already
      // leaves the shading filter on its static default, same spirit as
      // that branch's own imperfect guess.
      var shadeImg = garment === "Hoodie" ? shadeImgHoodie : garment === "Tee" ? shadeImgTee : null;
      if (shadeImg && teePhotos && teePhotos.back) {
        shadeImg.setAttribute("href", teePhotos.back);
      }

      garmentPath.setAttribute("d", GARMENT_SHAPES[garment] || GARMENT_SHAPES.Tee);
      garmentPath.style.fill = color.fill;
      garmentPath.style.stroke = strokeTone;

      var isHoodie = garment === "Hoodie";
      hoodPath.classList.toggle("vc-hidden", !isHoodie);
      if (isHoodie) {
        hoodPath.setAttribute("d", HOOD_SHAPE);
        hoodPath.style.fill = color.fill;
        hoodPath.style.stroke = strokeTone;
      }
      pocketPath.classList.toggle("vc-hidden", !isHoodie);
      if (isHoodie) {
        pocketPath.setAttribute("d", POCKET_SHAPE);
        pocketPath.style.fill = color.fill;
        pocketPath.style.stroke = strokeTone;
      }

      var isTeeOrHoodie = garment === "Tee" || garment === "Hoodie";
      Array.prototype.forEach.call(ribLines, function (el) {
        el.classList.toggle("vc-hidden", !isTeeOrHoodie);
        el.style.stroke = strokeTone;
      });
      Array.prototype.forEach.call(frontDetails, function (el) {
        el.style.stroke = strokeTone;
        if (el.tagName === "circle" || el.classList.contains("vc-string-path")) el.style.fill = strokeTone;
      });

      var isCap = garment === "Cap";
      Array.prototype.forEach.call(capDetails, function (el) {
        el.classList.toggle("vc-hidden", !isCap);
        el.style.stroke = strokeTone;
        if (el.classList.contains("vc-cap-button")) el.style.fill = color.fill;
      });

      var isSocks = garment === "Socks";
      Array.prototype.forEach.call(sockRibs, function (el) {
        el.classList.toggle("vc-hidden", !isSocks);
        el.style.stroke = strokeTone;
      });

      // Reference line and verse body are the same single color — matches
      // the real mockup reference (one ink color for the whole print,
      // not a two-tone scheme). See the matching change in render.js.
      // textInk: pale pastel garments print the verse (and chest logo) in soft charcoal (keep in
      // step with TEXT_INK_BY_COLOR in worker/src/products.js). The chest logo
      // still follows color.ink.
      var inkTone = color.textInk || (color.ink === "light" ? "#ffffff" : "#000000");
      printText.style.color = inkTone;
      // Charcoal text skips the fabric-shading blend (it lightens dark ink) — see .vc-print-text[data-vc-ink] in the CSS.
      shirtStage.setAttribute("data-vc-ink", color.textInk ? "soft" : "");
      // Opposite tone, used for the legibility halo (see .vc-print-halo
      // in verse-customizer.css) — keeps midtone heather colors readable.
      printText.style.setProperty("--vc-print-halo", color.textInk ? "transparent" : color.ink === "light" ? "#211d18" : "#f4f1e9");
      frontLogoImg.classList.toggle("vc-ink-light", color.ink === "light");
      applyViewState();
      updateAddToCartState();
    }

    colorSel.addEventListener("change", updateGarmentChrome);
    sizeSel.addEventListener("change", updateAddToCartState);

    // --- Mode tabs ---

    modeTabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        mode = tab.dataset.mode;
        root.setAttribute("data-vc-mode", mode);
        modeTabs.forEach(function (t) { t.classList.toggle("active", t === tab); });
        popularForm.classList.toggle("vc-hidden", mode !== "popular");
        manualForm.classList.toggle("vc-hidden", mode !== "manual");
        mysteryForm.classList.toggle("vc-hidden", mode !== "mystery");
        currentTheme = null;
        lastVerseIndex = -1;
        Array.prototype.forEach.call(themeGrid.children, function (c) { c.classList.remove("active"); });
        rerollBtn.disabled = true;
        clearSelection();
      });
    });

    // --- Popular verses: tap a card, done ---

    var popularGrid = $(".vc-popular-grid");
    var translationPopularSel = $(".vc-translation-popular-select");
    var selectedPopularIndex = -1;

    // A Popular verse's reference can differ by translation (Psalm 23:1 is Psalm 22:1 in the Douay-Rheims).
    function popularRef(entry, tr) { return entry["ref_" + tr] || entry.ref; }

    POPULAR_VERSES.forEach(function (entry, index) {
      var card = document.createElement("button");
      card.type = "button";
      card.className = "vc-theme-card vc-popular-card";
      card.dataset.index = String(index);
      card.innerHTML =
        '<span class="vc-t">' + escapeHtml(popularRef(entry, translationPopularSel.value)) + '</span>' +
        '<span class="vc-d">' + escapeHtml(entry[translationPopularSel.value] || "") + '</span>';
      card.addEventListener("click", function () { selectPopular(index); });
      popularGrid.appendChild(card);
    });
    refreshPopularCards();

    function selectPopular(index) {
      selectedPopularIndex = index;
      Array.prototype.forEach.call(popularGrid.children, function (c, i) {
        c.classList.toggle("active", i === index);
      });
      translationPopularSel.disabled = false;
      var entry = POPULAR_VERSES[index];
      selected = { text: entry[translationPopularSel.value], reference: popularRef(entry, translationPopularSel.value), translation: translationPopularSel.value };
      renderPreview(true);
    }

    // The cards show the verse in whichever translation is selected, so the
    // list always matches the preview (it used to be hard-wired to KJV).
    function refreshPopularCards() {
      Array.prototype.forEach.call(popularGrid.children, function (c, i) {
        var text = POPULAR_VERSES[i][translationPopularSel.value];
        c.hidden = !text; // a verse with no wording in this translation (the Catholic ones) is not offered
        var d = c.querySelector(".vc-d");
        if (d) d.textContent = text || "";
        var title = c.querySelector(".vc-t");
        if (title) title.textContent = popularRef(POPULAR_VERSES[i], translationPopularSel.value);
      });
    }

    // After a saved draft / cart edit puts a verse back, make the list say the
    // same thing as the preview: same translation in the menu and on the cards,
    // and the matching card highlighted when the verse is one of the popular picks.
    function syncPopularToSelected() {
      var tr = selected.translation;
      if (tr && Array.prototype.some.call(translationPopularSel.options, function (o) { return o.value === tr; })) {
        translationPopularSel.value = tr;
      }
      refreshPopularCards();
      selectedPopularIndex = -1;
      POPULAR_VERSES.forEach(function (e, i) {
        if (popularRef(e, tr) === selected.reference && e[tr] === selected.text) selectedPopularIndex = i;
      });
      Array.prototype.forEach.call(popularGrid.children, function (c, i) {
        c.classList.toggle("active", i === selectedPopularIndex);
      });
    }

    translationPopularSel.addEventListener("change", function () {
      refreshPopularCards();
      if (selectedPopularIndex < 0) {
        // The preview is showing a verse that did not come from this list (restored
        // from another picker): clear it rather than leave it in the old translation.
        if (selected.text) clearSelection();
        return;
      }
      var entry = POPULAR_VERSES[selectedPopularIndex];
      if (!entry[translationPopularSel.value]) {
        // e.g. a Catholic-only verse while switching away from the Douay-Rheims: it has no wording there
        selectedPopularIndex = -1;
        Array.prototype.forEach.call(popularGrid.children, function (c) { c.classList.remove("active"); });
        clearSelection();
        return;
      }
      selected = { text: entry[translationPopularSel.value], reference: popularRef(entry, translationPopularSel.value), translation: translationPopularSel.value };
      renderPreview(false);
    });

    // --- Manual picker: book -> chapter -> verse range -> translation ---

    // The seven Catholic books are listed only while the Douay-Rheims is the chosen translation.
    function buildBookOptions() {
      var douayRheims = translationSel.value === "dra";
      Array.prototype.slice.call(bookSel.options).forEach(function (o) { if (o.value) bookSel.removeChild(o); });
      BOOKS.forEach(function (b) {
        if (b.catholic && !douayRheims) return;
        var opt = document.createElement("option");
        opt.value = b.id;
        opt.textContent = b.name;
        opt.dataset.name = b.name;
        bookSel.appendChild(opt);
      });
    }
    buildBookOptions();

    function resetSelect(sel, placeholder) {
      sel.innerHTML = "";
      var opt = document.createElement("option");
      opt.value = "";
      opt.textContent = placeholder;
      sel.appendChild(opt);
      sel.disabled = true;
    }

    bookSel.addEventListener("change", function () {
      resetSelect(chapterSel, "—");
      resetSelect(verseFromSel, "—");
      resetSelect(verseToSel, "—");
      clearSelection();

      if (!bookSel.value) return;

      chapterSel.disabled = true;
      chapterSel.innerHTML = '<option value="">Loading…</option>';

      var chapterListId = ++chapterListReq;
      var chaptersRequest = (isCatholicBook(bookSel.value) || (hasHostedDr(bookSel.value) && translationSel.value === "dra"))
        ? loadDrBook(bookSel.value).then(function (book) {
            return { chapters: Object.keys(book).map(Number).sort(function (a, b) { return a - b; }).map(function (n) { return { chapter: n }; }) };
          })
        : fetchJson(BIBLE_API_BASE + "/data/web/" + bookSel.value);
      chaptersRequest
        .then(function (data) {
          if (chapterListId !== chapterListReq) return; // a newer request has taken over
          chapterSel.innerHTML = '<option value="">Choose a chapter…</option>';
          data.chapters.forEach(function (c) {
            var opt = document.createElement("option");
            opt.value = c.chapter;
            opt.textContent = "Chapter " + c.chapter;
            chapterSel.appendChild(opt);
          });
          chapterSel.disabled = false;
        })
        .catch(function () {
          if (chapterListId !== chapterListReq) return;
          chapterSel.innerHTML = '<option value="">Couldn’t load chapters — try again</option>';
        });
    });

    var chapterListReq = 0; // newest chapter-list request wins
    var currentChapterVerses = null; // cached verses array from the last chapter fetch

    // --- NIV (hosted text) ---
    var nivBookCache = {};
    function loadNivBook(bookId) {
      if (nivBookCache[bookId]) return Promise.resolve(nivBookCache[bookId]);
      var url = (window.CLVRY_NIV_URLS || {})[bookId];
      if (!url) return Promise.reject(new Error("NIV text unavailable"));
      return fetchJson(url).then(function (data) {
        nivBookCache[bookId] = data;
        return data;
      });
    }
    // --- Douay-Rheims: the Catholic books are hosted text, like the NIV ---
    function isCatholicBook(bookId) { return BOOKS.some(function (b) { return b.id === bookId && b.catholic; }); } // exists in the Douay-Rheims only
    function hasHostedDr(bookId) { return !!(window.CLVRY_DR_URLS || {})[bookId]; } // Douay-Rheims text is hosted here (the 7 Catholic books, plus Esther and Daniel with their extra chapters)
    var drBookCache = {};
    function loadDrBook(bookId) {
      if (drBookCache[bookId]) return Promise.resolve(drBookCache[bookId]);
      var url = (window.CLVRY_DR_URLS || {})[bookId];
      if (!url) return Promise.reject(new Error("Douay-Rheims text unavailable"));
      return fetchJson(url).then(function (data) { drBookCache[bookId] = data; return data; });
    }
    function drChapterVerses(bookId, chapter) {
      return loadDrBook(bookId).then(function (book) {
        var ch = book[String(chapter)];
        if (!ch) throw new Error("Douay-Rheims chapter missing");
        return Object.keys(ch).map(Number).sort(function (a, b) { return a - b; }).map(function (n) { return { verse: n, text: ch[n] }; });
      });
    }
    // Same shape bible-api.com returns ([{ verse, text }]). A few verses are
    // genuinely absent from the NIV (e.g. Matthew 17:21), so verse numbers
    // can have gaps — they come from the data, not a 1..n count.
    function nivChapterVerses(bookId, chapter) {
      return loadNivBook(bookId).then(function (book) {
        var ch = book[String(chapter)];
        if (!ch) throw new Error("NIV chapter missing");
        return Object.keys(ch)
          .map(Number)
          .sort(function (a, b) { return a - b; })
          .map(function (n) { return { verse: n, text: ch[n] }; });
      });
    }
    // A verse picked from the middle of a sentence starts lower-case and may
    // end on a ; or , — capitalise it and close it with a full stop, same as
    // the hand-checked Popular/Surprise Me NIV text.
    function tidyNivSelection(text) {
      text = text.trim();
      if (!text) return text;
      text = text.charAt(0).toUpperCase() + text.slice(1);
      return text.replace(/[;,:]$/, ".");
    }

    /**
     * Fetches the current chapter in the current translation and
     * repopulates the "from" dropdown. When `preserve` is true (a
     * translation change, not a fresh chapter pick), the caller's
     * existing from/to selection is restored afterward instead of
     * being wiped — the wording changes, not which verse was chosen.
     */
    var chapterReqId = 0;
    function loadChapter(preserve) {
      var reqId = ++chapterReqId;
      var preservedFrom = preserve ? verseFromSel.value : null;
      var preservedTo = preserve ? verseToSel.value : null;

      currentChapterVerses = null;
      verseFromSel.disabled = true;
      verseFromSel.innerHTML = '<option value="">Loading…</option>';
      if (!preserve) {
        resetSelect(verseToSel, "—");
        clearSelection();
      }

      var bookName = bookSel.options[bookSel.selectedIndex].dataset.name;
      var ref = encodeURIComponent(bookName) + "+" + chapterSel.value;

      // NIV isn't on bible-api.com: its text is hosted as one JSON asset per
      // book (see CLVRY_NIV_URLS in verse-customizer.liquid). Everything
      // after this fetch is identical for every translation.
      var chapterRequest = translationSel.value === "niv"
        ? nivChapterVerses(bookSel.value, chapterSel.value).then(function (verses) { return { verses: verses }; })
        : (translationSel.value === "dra" && hasHostedDr(bookSel.value))
          ? drChapterVerses(bookSel.value, chapterSel.value).then(function (verses) { return { verses: verses }; })
          : fetchJson(BIBLE_API_BASE + "/" + ref + "?translation=" + translationSel.value);
      return chapterRequest
        .then(function (data) {
          if (reqId !== chapterReqId) return;
          currentChapterVerses = data.verses;
          verseFromSel.innerHTML = '<option value="">Choose a verse…</option>';
          data.verses.forEach(function (v) {
            var opt = document.createElement("option");
            opt.value = v.verse;
            opt.textContent = "Verse " + v.verse;
            verseFromSel.appendChild(opt);
          });
          verseFromSel.disabled = false;

          if (preserve && preservedFrom) {
            verseFromSel.value = preservedFrom;
            if (verseFromSel.value !== preservedFrom) {
              // This translation does not have that verse number: clear the old wording.
              clearSelection();
              return;
            }
            populateVerseTo(parseInt(preservedFrom, 10));
            if (preservedTo) verseToSel.value = preservedTo;
            resolveManualSelection();
          }
        })
        .catch(function () {
          if (reqId !== chapterReqId) return;
          verseFromSel.innerHTML = '<option value="">Couldn’t load verses — try again</option>';
          // A translation switch that failed must not leave the old wording on the preview.
          if (preserve) clearSelection();
        });
    }

    chapterSel.addEventListener("change", function () {
      resetSelect(verseFromSel, "—");
      resetSelect(verseToSel, "—");
      clearSelection();
      currentChapterVerses = null;

      if (!chapterSel.value) return;
      loadChapter(false);
    });

    function populateVerseTo(fromNum) {
      var eligible = currentChapterVerses.filter(function (v) { return v.verse >= fromNum; });
      verseToSel.innerHTML = "";
      eligible.forEach(function (v) {
        var opt = document.createElement("option");
        opt.value = v.verse;
        opt.textContent = v.verse === fromNum ? "Verse " + v.verse + " only" : "Verse " + v.verse;
        verseToSel.appendChild(opt);
      });
      verseToSel.value = String(fromNum);
      verseToSel.disabled = false;
    }

    verseFromSel.addEventListener("change", function () {
      resetSelect(verseToSel, "—");
      if (!verseFromSel.value || !currentChapterVerses) {
        clearSelection();
        return;
      }

      populateVerseTo(parseInt(verseFromSel.value, 10));
      resolveManualSelection();
    });

    verseToSel.addEventListener("change", resolveManualSelection);
    // Esther and Daniel have extra chapters in the Douay-Rheims, so their chapter list depends on the translation.
    function rebuildChapterList() {
      // Psalms are numbered differently in the Douay-Rheims, so a chosen Psalm is not carried across.
      var keep = bookSel.value === "PSA" ? "" : chapterSel.value;
      var reqBook = bookSel.value;
      var chapterListId = ++chapterListReq;
      var request = translationSel.value === "dra"
        ? loadDrBook(reqBook).then(function (book) { return Object.keys(book).map(Number).sort(function (a, b) { return a - b; }); })
        : fetchJson(BIBLE_API_BASE + "/data/web/" + reqBook).then(function (data) { return data.chapters.map(function (c) { return Number(c.chapter); }); });
      request.then(function (list) {
        if (chapterListId !== chapterListReq || bookSel.value !== reqBook) return;
        chapterSel.innerHTML = '<option value="">Choose a chapter…</option>';
        list.forEach(function (n) {
          var opt = document.createElement("option");
          opt.value = n;
          opt.textContent = "Chapter " + n;
          chapterSel.appendChild(opt);
        });
        chapterSel.disabled = false;
        if (keep && list.indexOf(Number(keep)) >= 0) {
          chapterSel.value = keep;
          loadChapter(true);
        } else {
          chapterSel.value = "";
          resetSelect(verseFromSel, "—");
          resetSelect(verseToSel, "—");
          currentChapterVerses = null;
          clearSelection();
        }
      }).catch(function () {
        if (chapterListId !== chapterListReq) return;
        chapterSel.innerHTML = '<option value="">Couldn’t load chapters — try again</option>';
      });
    }

    translationSel.addEventListener("change", function () {
      // Show or hide the Catholic books; a Catholic book that is no longer offered is cleared.
      var chosenBook = bookSel.value;
      buildBookOptions();
      if (chosenBook && !Array.prototype.some.call(bookSel.options, function (o) { return o.value === chosenBook; })) {
        bookSel.value = "";
        bookSel.dispatchEvent(new Event("change"));
        return;
      }
      if (chosenBook) bookSel.value = chosenBook;
      if (bookSel.value && hasHostedDr(bookSel.value) && !isCatholicBook(bookSel.value)) {
        rebuildChapterList();
        return;
      }
      // Translation changes the wording, so the chapter has to be
      // re-fetched — but the customer's already-chosen verse (range)
      // is preserved rather than forcing them to reselect it.
      if (!chapterSel.value) {
        if (selected.text) clearSelection();
        return;
      }
      loadChapter(true);
    });

    function resolveManualSelection() {
      if (!chapterSel.value || !verseFromSel.value || !verseToSel.value || !currentChapterVerses) return;

      var fromNum = parseInt(verseFromSel.value, 10);
      var toNum = parseInt(verseToSel.value, 10);
      var span = currentChapterVerses.filter(function (v) { return v.verse >= fromNum && v.verse <= toNum; });
      var text = span.map(function (v) { return v.text.trim(); }).join(" ");
      if (translationSel.value === "niv" || translationSel.value === "dra") text = tidyNivSelection(text);
      var bookName = bookSel.options[bookSel.selectedIndex].dataset.name;
      var reference = bookName + " " + chapterSel.value + ":" + (fromNum === toNum ? fromNum : fromNum + "-" + toNum);

      selected = { text: text, reference: reference, translation: translationSel.value };
      renderPreview(true);
    }

    // --- Mystery mode: theme -> reveal -> reroll ---

    Object.keys(THEMES).forEach(function (theme) {
      var card = document.createElement("button");
      card.type = "button";
      card.className = "vc-theme-card";
      card.dataset.theme = theme;
      card.innerHTML = '<span class="vc-t">' + theme + '</span><span class="vc-d">' + THEMES[theme].desc + "</span>";
      card.addEventListener("click", function () { selectTheme(theme); });
      themeGrid.appendChild(card);
    });

    function selectTheme(theme) {
      currentTheme = theme;
      Array.prototype.forEach.call(themeGrid.children, function (c) {
        c.classList.toggle("active", c.dataset.theme === theme);
      });
      lastVerseIndex = -1;
      translationMysterySel.disabled = false;
      rerollBtn.disabled = false;
      revealVerse();
    }

    function revealVerse() {
      var pool = THEMES[currentTheme].verses;
      var idx = Math.floor(Math.random() * pool.length);
      if (pool.length > 1 && idx === lastVerseIndex) idx = (idx + 1) % pool.length;
      lastVerseIndex = idx;
      var entry = pool[idx];
      selected = {
        text: entry[translationMysterySel.value],
        reference: entry.ref,
        translation: translationMysterySel.value
      };
      renderPreview(true);
    }

    rerollBtn.addEventListener("click", revealVerse);
    translationMysterySel.addEventListener("change", function () {
      if (currentTheme && lastVerseIndex >= 0) {
        var entry = THEMES[currentTheme].verses[lastVerseIndex];
        selected = { text: entry[translationMysterySel.value], reference: entry.ref, translation: translationMysterySel.value };
        renderPreview(false);
      } else if (selected.text) {
        clearSelection();
      }
    });

    // --- Preview rendering ---

    // The enlarge button says what it is for: once a verse is chosen the
    // preview is too small to read on a phone, so invite the tap.
    function setEnlargeLabel(hasVerse) {
      var btn = root.querySelector(".vc-enlarge-btn");
      if (!btn) return;
      var label = btn.querySelector(".vc-enlarge-label");
      var text = hasVerse ? "Tap to read your verse" : "Tap to enlarge";
      if (label) {
        label.textContent = text;
        label.setAttribute("data-short", hasVerse ? "Tap to read" : "Enlarge");
      }
      btn.setAttribute("aria-label", hasVerse ? "Enlarge the preview to read your verse" : "Enlarge the print preview");
      btn.classList.toggle("vc-enlarge-btn--verse", !!hasVerse);
    }

    function clearSelection() {
      selected = { text: null, reference: null, translation: "kjv" };
      setEnlargeLabel(false);
      if (reviewVerseTextEl) reviewVerseTextEl.textContent = "";
      printText.innerHTML = '<span class="vc-empty">Print area</span>';
      printText.classList.add("vc-print-empty");
      fitBadge.textContent = "";
      citation.textContent = "— select a verse —";
      updateAddToCartState();
    }

    function renderPreview(animate) {
      if (!selected.text) return;
      printText.classList.remove("vc-reveal-in");
      printText.classList.remove("vc-print-empty");

      // fitVerse does the real work: finds the composition scale (font
      // sizes for both the reference line and the verse) that fits the
      // box, re-wrapping at each candidate size against the box's real
      // fixed pixel width — see its doc comment for why that (not a
      // post-hoc CSS shrink) is what makes a long verse actually use the
      // print area's width the way the real print output does.
      var fit = fitVerse(printText, selected.text);
      var verseLinesHtml = fit.lines
        .map(function (line) {
          return '<div class="vc-print-verse-line">' + escapeHtml(line) + "</div>";
        })
        .join("");
      printText.innerHTML =
        '<div class="vc-print-inner">' +
        '<div class="vc-print-ref">' + spaceReference(fixApostrophes(selected.reference)) + '</div>' +
        '<div class="vc-print-verse">' + verseLinesHtml + "</div>" +
        "</div>";
      var align = alignForLineCount(fit.lines.length);
      var refEl = printText.querySelector(".vc-print-ref");
      var verseEl = printText.querySelector(".vc-print-verse");
      refEl.style.fontSize = fit.refPx + "px";
      refEl.style.lineHeight = VERSE_PRESET.lineHeight;
      refEl.style.marginBottom = fit.gapPx + "px";
      refEl.style.textAlign = align;
      verseEl.style.fontSize = fit.versePx + "px";
      verseEl.style.lineHeight = fit.lineHeight;
      verseEl.style.textAlign = align;
      if (animate) {
        void printText.offsetWidth;
        printText.classList.add("vc-reveal-in");
      }
      fitBadge.classList.toggle("vc-fit-badge--warn", fit.overflowing);
      // Only shown when the verse genuinely can't print well; an empty badge
      // is hidden by CSS (.vc-fit-badge:empty). It used to read "Auto-fit: 9px",
      // which meant nothing to customers.
      fitBadge.textContent = fit.overflowing ? "Long passage: the lettering will print fairly small" : "";
      citation.textContent = selected.reference + " (" + TRANSLATION_NAMES[selected.translation] + ")";
      setEnlargeLabel(true);
      saveDraft();
      if (reviewVerseTextEl) reviewVerseTextEl.textContent = "\u201C" + fixApostrophes(selected.text) + "\u201D";
      updateAddToCartState();
    }

    // Re-measures the current verse against the box's real pixel size —
    // covers orientation changes and any resize of the preview panel,
    // not just the initial render.
    var resizeTimer = null;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (selected.text) renderPreview(false);
      }, 150);
    });

    // Asamila (the real print font, verse-customizer.liquid) loads with
    // font-display: swap — a fallback font paints first, and canvas
    // measureText resolves the SAME "Asamila, Cardo, Georgia, ..." stack
    // independently, so a renderPreview() that runs before Asamila has
    // actually finished loading measures/wraps against the fallback's
    // (different, usually wider) glyph metrics instead of Asamila's real
    // ones. Confirmed directly: the very first verse selection right
    // after page load wrapped noticeably narrower than the print-area
    // box actually allowed, while the same verse re-selected a moment
    // later (font by then loaded) filled it properly. document.fonts
    // .load() both kicks off the fetch if it hasn't already started and
    // resolves once it's genuinely ready (unlike document.fonts.ready,
    // which only waits on fonts already in flight) — re-render once it
    // resolves so the first verse a customer sees isn't laid out against
    // the wrong font.
    if (window.document.fonts && document.fonts.load) {
      document.fonts.load("400 16px Asamila").catch(function () {}).then(function () {
        if (selected.text) renderPreview(false);
      });
    }

    function escapeHtml(s) {
      return s.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }

    // --- Front/back view + small-format garments ---

    // Products with a real Print option (Tee/Hoodie) decide verse-
    // requirement dynamically from the customer's Print selection;
    // everything else (Cap/Socks) keeps the static per-product value
    // baked in at render time (data-full-verse on the root element).
    function verseRequiredNow() {
      if (printValues.length) return printSel.value !== "Logo Only";
      return fullVerse;
    }

    // Any garment with a real Print option (Tee/Hoodie/Cap) and "Logo
    // Only" currently selected: still a full-size, always-shown garment
    // (unlike Socks, which has no Print option and stays on the static
    // small-format path below) — just with nothing extra beyond the
    // logo, so it gets its own clean treatment: front view forced,
    // front logo shown, no "small-format" messaging or verse-picker UI.
    function isLogoOnlyBigGarment() {
      // Cap (Otto Cap 31-069) is always logo-only now — no Print option,
      // no verse customization at all (product decision, 2026-09-02) —
      // so it always takes this same clean "show the logo, no verse UI"
      // treatment, not just when a Print pill happens to say so.
      if (garment === "Cap") return true;
      return printValues.length > 0 && !verseRequiredNow();
    }

    function applyViewState() {
      if (isLogoOnlyBigGarment()) {
        currentView = "front";
        viewToggle.classList.add("vc-hidden");
        printText.classList.add("vc-hidden");
        smallFormatNote.classList.add("vc-hidden");
        fitBadge.classList.add("vc-hidden");
        frontLogoLayer.classList.toggle("vc-hidden", usingRealTeePhoto);
        // usingRealTeePhoto (not a garment-name check) — true for Tee/
        // Hoodie always, and for Cap whenever the selected color has a
        // real photo (both its colors do). Forcing these visible for a
        // color with no real photo would show a stale/wrong image over
        // that color's SVG illustration instead.
        if (usingRealTeePhoto) {
          teePhotoBack.classList.add("vc-hidden");
          teePhotoFront.classList.remove("vc-hidden");
        }
        return;
      }
      if (!verseRequiredNow()) {
        // Socks only now — Cap always takes the isLogoOnlyBigGarment()
        // branch above instead (no Print option, no verse UI at all).
        viewToggle.classList.add("vc-hidden");
        printText.classList.add("vc-hidden");
        frontLogoLayer.classList.add("vc-hidden");
        smallFormatNote.classList.remove("vc-hidden");
        fitBadge.classList.add("vc-hidden");
        return;
      }
      viewToggle.classList.remove("vc-hidden");
      smallFormatNote.classList.add("vc-hidden");
      viewBtns.forEach(function (b) { b.classList.toggle("active", b.dataset.view === currentView); });
      printText.classList.toggle("vc-hidden", currentView === "front");
      frontLogoLayer.classList.toggle("vc-hidden", currentView === "back" || usingRealTeePhoto);
      fitBadge.classList.toggle("vc-hidden", currentView === "front");

      if (usingRealTeePhoto) {
        teePhotoBack.classList.toggle("vc-hidden", currentView === "front");
        teePhotoFront.classList.toggle("vc-hidden", currentView === "back");
      }

      // Pocket + drawstrings are front-of-hoodie details — hide them on
      // the back view even though updateGarmentChrome() already marked
      // them "eligible" for this garment.
      var showFrontDetails = garment === "Hoodie" && currentView === "front";
      pocketPath.classList.toggle("vc-hidden", !showFrontDetails);
      Array.prototype.forEach.call(frontDetails, function (el) {
        el.classList.toggle("vc-hidden", !showFrontDetails);
      });
    }

    viewBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        currentView = btn.dataset.view;
        applyViewState();
        // Reset any zoom/pan left over from the view just switched away
        // from — without this, hovering/zooming on the back print (a
        // wide box, easy to zoom into a corner of) then tapping "Front"
        // carried that same pan position over, landing on an arbitrary
        // cropped corner of the front view instead of the small,
        // centered front logo it's supposed to show. resetZoomAndPan is
        // defined below (hoisted within this same init function), safe
        // to call here since this handler only runs later, on click.
        if (typeof resetZoomAndPan === "function") resetZoomAndPan();
      });
    });

    // --- Zoom — inspect placement up close without leaving the page ---
    //
    // Primary interaction (devices with a real pointer): hovering over the
    // stage magnifies it, focused on wherever the cursor is — moving the
    // mouse pans the zoomed view. The step +/- buttons are a fallback for
    // touch devices, which get no hover at all (CSS hides whichever one
    // doesn't apply to the current device — see the `hover`/`pointer`
    // media query in verse-customizer.css).

    // 2026-10-15: the hover zoom is a fixed 4.0x. It used to be 2.4x, capped lower on wide print boxes so a whole line
    // always fit; customers still found long verses hard to read, so it is now a flat 4.0x everywhere. At this strength a
    // long line is wider than the window: move the mouse sideways to read the rest (the zoom follows the cursor).
    var HOVER_ZOOM_SCALE = 4.0;

    // True while the phone "Tap to enlarge" overlay (further down) has
    // the stage reparented into it. The hover/pinch handlers below stand
    // down then — the overlay is a plain scrollable view of the stage.
    var enlargeOpen = false;
    // Hover-follow zoom is a mouse feature. Touch browsers synthesise a
    // mousemove on every tap, which used to kick the stage to 2.4x just
    // from tapping it — only honour real hover-capable pointers.
    var finePointer = window.matchMedia("(hover: hover) and (pointer: fine)");

    // A fixed zoom scale only works while the print box is narrow enough
    // to still fit on screen once magnified — it was fine against the
    // ORIGINAL back-print box (33% of stage width), but the 2026-09-24
    // enlargement (fixing false "too long" warnings — see the doc
    // comment on .vc-print-text in verse-customizer.css) widened it to
    // 48% on Tee / 52% on Hoodie. 2.4x of a 48%+ -wide box is wider than
    // the viewport itself, so hovering anywhere guaranteed a clipped
    // line — there was no cursor position that could ever show a
    // complete line of a long verse, not just an edge case. This
    // computes the real ceiling from the box's own current rendered
    // width instead of a hardcoded number, so a full line always fits
    // (panning only ever needed vertically, for extra lines) — the same
    // "always fit the design region" behavior most native product-
    // customizer zooms (Printful's own mockup zoom included) use,
    // rather than an arbitrary fixed multiplier. Self-corrects if the
    // box is resized again later, or on Logo Only/front view (no back
    // box in the DOM to measure) it falls back to the original fixed
    // scale, since the front logo is small either way.
    var HOVER_ZOOM_FIT_MARGIN = 0.94; // small margin so the box isn't flush against both edges

    function computeHoverZoomScale() {
      var printText = shirtStage.querySelector(".vc-print-text");
      var stageWidth = shirtStage.offsetWidth;
      if (!printText || !stageWidth) return HOVER_ZOOM_SCALE;
      var boxWidth = printText.offsetWidth;
      if (!boxWidth) return HOVER_ZOOM_SCALE; // hidden (front view) or not yet laid out
      var fitScale = (stageWidth / boxWidth) * HOVER_ZOOM_FIT_MARGIN;
      return HOVER_ZOOM_SCALE; // flat 4.0x (the old fit ceiling no longer applies, see above)
    }

    stageViewport.addEventListener("mousemove", function (e) {
      if (enlargeOpen || !finePointer.matches) return;
      var rect = stageViewport.getBoundingClientRect();
      var xPct = ((e.clientX - rect.left) / rect.width) * 100;
      var yPct = ((e.clientY - rect.top) / rect.height) * 100;
      shirtStage.classList.remove("vc-shirt-stage--stepped");
      shirtStage.style.transformOrigin = xPct + "% " + yPct + "%";
      shirtStage.style.transform = "scale(" + computeHoverZoomScale() + ")";
    });
    stageViewport.addEventListener("mouseleave", function () {
      if (enlargeOpen || !finePointer.matches) return;
      // Only the leave step eases (via --stepped's transition) — the
      // next mousemove removes it again so cursor-tracking stays instant.
      shirtStage.classList.add("vc-shirt-stage--stepped");
      shirtStage.style.transform = "scale(1)";
    });

    // --- Step zoom (touch fallback) + pinch/drag (touch primary) ---
    //
    // The +/- buttons remain (some users expect them, and they're the
    // only option for screen-reader/switch-control use), but touch
    // devices now also get real pinch-to-zoom and single-finger drag-to-
    // pan directly on the stage, same as any native photo viewer. Pan is
    // tracked separately from zoom (panX/panY, in real pixels — see the
    // translate-then-scale math below) and clamped so the image can
    // never be dragged past its own scaled edge, leaving blank space in
    // the viewport.

    // On phones/tablets (touch only) this CSS-scale zoom is switched off: it
    // just magnifies a bitmap, so the verse text — drawn with an SVG shading
    // filter — turns blurry past ~150%. "Tap to enlarge" (below) re-lays the
    // preview out at the bigger size instead, which stays sharp, so that is
    // the zoom on touch devices. Mouse users keep hover-zoom.
    var touchOnly = !!(window.matchMedia && window.matchMedia("(hover: none) and (pointer: coarse)").matches);

    var ZOOM_MIN = 1;
    var ZOOM_MAX = 3;
    var ZOOM_STEP = 0.5;
    var stepZoomLevel = 1;
    var panX = 0;
    var panY = 0;

    // transform: translate(...) scale(...) applies scale first (around
    // transform-origin: center), then shifts by panX/panY in real,
    // unscaled pixels — so pan distance stays consistent regardless of
    // zoom level, and doesn't itself get multiplied by scale.
    function applyStepZoom() {
      shirtStage.classList.add("vc-shirt-stage--stepped");
      shirtStage.style.transformOrigin = "center center";

      // Clamp pan so the scaled image's edge can't be dragged past the
      // viewport's edge (leaving a blank gap) — half the image's
      // overhang past the viewport in each direction, in each axis.
      var rect = stageViewport.getBoundingClientRect();
      var maxPanX = (rect.width * (stepZoomLevel - 1)) / 2;
      var maxPanY = (rect.height * (stepZoomLevel - 1)) / 2;
      panX = Math.max(-maxPanX, Math.min(maxPanX, panX));
      panY = Math.max(-maxPanY, Math.min(maxPanY, panY));

      shirtStage.style.transform =
        "translate(" + panX + "px, " + panY + "px) scale(" + stepZoomLevel + ")";
      zoomLevelLabel.textContent = Math.round(stepZoomLevel * 100) + "%";
      zoomInBtn.disabled = stepZoomLevel >= ZOOM_MAX;
      zoomOutBtn.disabled = stepZoomLevel <= ZOOM_MIN;
    }

    // Called on every Front/Back switch (see the viewBtns click handler
    // above) — without this, a zoom/pan left over from the view just
    // switched away from carried straight into the new one, landing on
    // an arbitrary cropped corner instead of that view's own centered
    // starting position. Clears both zoom paths (hover's inline
    // transform and step-zoom's tracked state) so every view always
    // opens the same way: centered, at 1x.
    function resetZoomAndPan() {
      stepZoomLevel = ZOOM_MIN;
      panX = 0;
      panY = 0;
      shirtStage.classList.remove("vc-shirt-stage--stepped");
      shirtStage.style.transform = "";
      shirtStage.style.transformOrigin = "";
      zoomLevelLabel.textContent = "100%";
      zoomInBtn.disabled = false;
      zoomOutBtn.disabled = true;
    }

    function touchDistance(touches) {
      var dx = touches[0].clientX - touches[1].clientX;
      var dy = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    var pinchStartDistance = 0;
    var pinchStartZoom = 1;
    var dragStartX = 0;
    var dragStartY = 0;
    var dragStartPanX = 0;
    var dragStartPanY = 0;
    var isDragging = false;

    stageViewport.addEventListener(
      "touchstart",
      function (e) {
        if (enlargeOpen || touchOnly) return;
        if (e.touches.length === 2) {
          isDragging = false;
          pinchStartDistance = touchDistance(e.touches);
          pinchStartZoom = stepZoomLevel;
        } else if (e.touches.length === 1 && stepZoomLevel > ZOOM_MIN) {
          // Only drag when already zoomed in — at 1x there's nothing to
          // pan, and this leaves normal page scroll untouched at rest.
          isDragging = true;
          dragStartX = e.touches[0].clientX;
          dragStartY = e.touches[0].clientY;
          dragStartPanX = panX;
          dragStartPanY = panY;
        }
      },
      { passive: true }
    );

    stageViewport.addEventListener(
      "touchmove",
      function (e) {
        if (enlargeOpen || touchOnly) return;
        if (e.touches.length === 2) {
          e.preventDefault(); // don't let the page scroll/zoom while pinching
          var scale = touchDistance(e.touches) / pinchStartDistance;
          stepZoomLevel = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, pinchStartZoom * scale));
          applyStepZoom();
        } else if (isDragging && e.touches.length === 1) {
          e.preventDefault();
          panX = dragStartPanX + (e.touches[0].clientX - dragStartX);
          panY = dragStartPanY + (e.touches[0].clientY - dragStartY);
          applyStepZoom();
        }
      },
      { passive: false }
    );

    stageViewport.addEventListener("touchend", function (e) {
      if (e.touches.length < 2) pinchStartDistance = 0;
      if (e.touches.length < 1) isDragging = false;
      // Snapped back to 1x (e.g. pinched back out) — recenter rather
      // than leaving a stale pan offset for the next zoom-in.
      if (stepZoomLevel <= ZOOM_MIN) {
        panX = 0;
        panY = 0;
        applyStepZoom();
      }
    });

    zoomInBtn.addEventListener("click", function () {
      stepZoomLevel = Math.min(ZOOM_MAX, stepZoomLevel + ZOOM_STEP);
      applyStepZoom();
    });
    zoomOutBtn.addEventListener("click", function () {
      stepZoomLevel = Math.max(ZOOM_MIN, stepZoomLevel - ZOOM_STEP);
      if (stepZoomLevel <= ZOOM_MIN) { panX = 0; panY = 0; }
      applyStepZoom();
    });
    applyStepZoom();

    // --- Enlarge (phones / touch) ---
    //
    // On a phone the preview panel is ~300px wide and the print box is
    // only ~38% of that, so the verse is a few px tall no matter how well
    // it fits. "Tap to enlarge" lifts the real stage into a full-screen
    // overlay and sizes it so the print box fills the screen width, then
    // lets the customer drag around it. The same stage element moves
    // (nothing is cloned), and renderPreview() re-fits the verse at the
    // new size — fitVerse() scales from a virtual 1000px box, so the
    // wrapping is identical to the small view, just bigger.
    var enlargeBtn = $(".vc-enlarge-btn");
    var enlargeOverlay = null;
    var enlargeScroll = null;
    var enlargeSizer = null;
    var enlargePlaceholder = null;
    var enlargeViewBtns = [];
    var enlargeFoot = null;
    var enlargeLastWidth = 0;
    var enlargeSavedScrollY = 0;
    var enlargeCoarse = window.matchMedia("(hover: none), (pointer: coarse), (max-width: 700px)");

    function buildEnlargeOverlay() {
      enlargeOverlay = document.createElement("div");
      enlargeOverlay.className = "vc-enlarge-overlay vc-hidden";
      enlargeOverlay.setAttribute("role", "dialog");
      enlargeOverlay.setAttribute("aria-modal", "true");
      enlargeOverlay.setAttribute("aria-label", "Enlarged print preview");
      enlargeOverlay.innerHTML =
        '<div class="vc-enlarge-bar">' +
          '<div class="vc-enlarge-views">' +
            '<button type="button" class="vc-enlarge-view" data-view="back">Back</button>' +
            '<button type="button" class="vc-enlarge-view" data-view="front">Front</button>' +
          "</div>" +
          '<button type="button" class="vc-enlarge-close">Close</button>' +
        "</div>" +
        '<div class="vc-enlarge-scroll"><div class="vc-enlarge-sizer"></div></div>' +
        '<div class="vc-enlarge-foot"></div>';
      root.appendChild(enlargeOverlay);
      enlargeScroll = enlargeOverlay.querySelector(".vc-enlarge-scroll");
      enlargeSizer = enlargeOverlay.querySelector(".vc-enlarge-sizer");
      enlargeFoot = enlargeOverlay.querySelector(".vc-enlarge-foot");
      enlargeViewBtns = Array.prototype.slice.call(enlargeOverlay.querySelectorAll(".vc-enlarge-view"));
      enlargeOverlay.querySelector(".vc-enlarge-close").addEventListener("click", closeEnlarge);
      enlargeViewBtns.forEach(function (b) {
        b.addEventListener("click", function () {
          Array.prototype.forEach.call(viewBtns, function (real) {
            if (real.dataset.view === b.dataset.view) real.click();
          });
          layoutEnlarge();
        });
      });
    }

    function syncEnlargeChrome() {
      var toggleHidden = viewToggle.classList.contains("vc-hidden");
      enlargeOverlay.querySelector(".vc-enlarge-views").classList.toggle("vc-hidden", toggleHidden);
      enlargeViewBtns.forEach(function (b) { b.classList.toggle("active", b.dataset.view === currentView); });
      enlargeFoot.textContent = selected.text ? citation.textContent : "";
      enlargeFoot.classList.toggle("vc-hidden", !selected.text);
    }

    // Sizes the stage so what matters (the print box on the back view,
    // the front logo if it's a separate layer) fills the screen width,
    // then scrolls it into the middle. Percent-positioned layers keep
    // their proportions at any stage size, so the fractions measured here
    // are the same ones the customer sees at 1x.
    function layoutEnlarge() {
      syncEnlargeChrome();
      var vw = enlargeScroll.clientWidth;
      var vh = enlargeScroll.clientHeight;
      var focal = null;
      if (printText.offsetWidth > 0) focal = printText;
      else if (frontLogoLayer.offsetWidth > 0) focal = frontLogoLayer;

      var fx = 0.5;
      var fy = 0.5;
      var stageW = vw * 2;
      if (focal) {
        var sw = shirtStage.offsetWidth;
        var sh = shirtStage.offsetHeight;
        fx = (focal.offsetLeft + focal.offsetWidth / 2) / sw;
        fy = (focal.offsetTop + focal.offsetHeight / 2) / sh;
        var want = focal === printText ? 0.94 * vw : 0.4 * vw;
        stageW = want / (focal.offsetWidth / sw);
      }
      stageW = Math.round(Math.max(vw * 1.6, Math.min(stageW, 1500)));

      enlargeSizer.style.width = stageW + "px";
      enlargeSizer.style.height = stageW + "px";
      if (selected.text) renderPreview(false);

      // The re-fit above can change nothing about the box's own position
      // (it's percent-based), so the fractions still hold.
      enlargeScroll.scrollLeft = Math.max(0, fx * stageW - vw / 2);
      enlargeScroll.scrollTop = Math.max(0, fy * stageW - vh / 2);
      enlargeLastWidth = vw;
    }

    function openEnlarge() {
      if (enlargeOpen) return;
      resetZoomAndPan();
      if (!enlargeOverlay) buildEnlargeOverlay();
      enlargeSavedScrollY = window.pageYOffset;
      // Placeholder keeps the panel's height so the page doesn't jump
      // while the stage is away.
      enlargePlaceholder = document.createElement("div");
      enlargePlaceholder.style.height = stageViewport.offsetHeight + "px";
      stageViewport.parentNode.insertBefore(enlargePlaceholder, stageViewport);
      enlargeSizer.appendChild(stageViewport);
      enlargeOpen = true;
      enlargeOverlay.classList.remove("vc-hidden");
      document.documentElement.classList.add("vc-enlarge-lock");
      layoutEnlarge();
      enlargeOverlay.querySelector(".vc-enlarge-close").focus({ preventScroll: true });
    }

    function closeEnlarge() {
      if (!enlargeOpen) return;
      enlargeOpen = false;
      enlargePlaceholder.parentNode.insertBefore(stageViewport, enlargePlaceholder);
      enlargePlaceholder.parentNode.removeChild(enlargePlaceholder);
      enlargePlaceholder = null;
      enlargeSizer.style.width = "";
      enlargeSizer.style.height = "";
      enlargeOverlay.classList.add("vc-hidden");
      document.documentElement.classList.remove("vc-enlarge-lock");
      resetZoomAndPan();
      if (selected.text) renderPreview(false);
      if (enlargeBtn) enlargeBtn.focus({ preventScroll: true });
      window.scrollTo(0, enlargeSavedScrollY);
    }

    if (enlargeBtn) {
      enlargeBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        openEnlarge();
      });
      // Tapping the preview itself does the same — the obvious thing to
      // try. Only at 1x, so a pinch/drag that happens to end in a click
      // never fires it.
      stageViewport.addEventListener("click", function () {
        if (enlargeOpen || !enlargeCoarse.matches || stepZoomLevel > ZOOM_MIN) return;
        openEnlarge();
      });
    }
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeEnlarge();
    });
    // Orientation change (width change only — mobile browsers also fire
    // resize as the URL bar collapses, which must not re-centre mid-pan).
    window.addEventListener("resize", function () {
      if (enlargeOpen && enlargeScroll.clientWidth !== enlargeLastWidth) layoutEnlarge();
    });
    // The enlarge button is absolutely positioned inside the stage; if the
    // viewport grows past phone/touch (rotate to desktop-sized window),
    // make sure we never leave the overlay stranded open.
    enlargeCoarse.addListener && enlargeCoarse.addListener(function (mq) {
      if (!mq.matches) closeEnlarge();
    });

    // --- Add to cart ---

    function updateAddToCartState() {
      var hasVerse = verseRequiredNow() ? !!selected.text : true; // Logo Only / small-format items don't require a verse
      var hasVariant = !!colorSel.value && !!sizeSel.value && (!printValues.length || !!printSel.value);
      addBtn.disabled = !(hasVerse && hasVariant);
      // Step 2's own Continue button shares the exact same "is a verse
      // actually selected" condition as Add to Cart — reusing hasVerse
      // here instead of a second copy of verseRequiredNow()/selected.text
      // logic keeps the two in sync automatically as this function's
      // definition of "has a verse" evolves.
      if (step2NextBtn) step2NextBtn.disabled = !hasVerse;
    }

    addBtn.addEventListener("click", function () {
      var variant = findVariant(colorSel.value, sizeSel.value, printValues.length ? printSel.value : null);
      if (!variant) {
        showError("That color/size combination isn't available.");
        return;
      }

      // Leading underscore hides these from the customer-facing cart
      // (Dawn's cart-drawer.liquid/main-cart-items.liquid both skip any
      // property whose name starts with "_") — Color/Size/Print/Garment
      // would otherwise show up a second time, duplicating what Dawn
      // already renders from the real Shopify variant options.
      // worker/src/shopify.js strips the underscore back off when
      // reading these for the order pipeline, so nothing downstream
      // needs to change. Reference/Verse/Translation stay unprefixed —
      // they're not shown anywhere else, so surfacing them in the cart
      // is useful, not redundant.
      var properties = {
        _Garment: garment,
        _Color: colorSel.value,
        _Size: sizeSel.value
      };
      if (printValues.length) properties._Print = printSel.value;
      if (verseRequiredNow() && selected.text) {
        properties.Reference = selected.reference;
        properties.Verse = selected.text;
        properties.Translation = TRANSLATION_NAMES[selected.translation];
      }

      atcLabel.classList.add("vc-hidden");
      atcSpinner.classList.remove("vc-hidden");
      addBtn.disabled = true;
      atcError.classList.add("vc-hidden");

      // Editing an existing cart line: unchanged -> just go back to the cart;
      // changed -> add the new version first (so a failure never loses the
      // customer's item), then remove the old line.
      var unchanged = !!editLine && String(editLine.variantId) === String(variant.id) &&
        Object.keys(properties).concat(Object.keys(editLine.properties)).every(function (k) {
          return (properties[k] || "") === (editLine.properties[k] || "");
        });
      var addPromise = unchanged
        ? Promise.resolve()
        : fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: variant.id, quantity: editLine ? editLine.quantity : 1, properties: properties })
          }).then(function (res) {
            if (!res.ok) return res.json().then(function (b) { throw new Error(b.description || "Couldn't add to cart"); });
            return res.json();
          }).then(function () {
            if (!editLine) return null;
            return fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: editLine.key, quantity: 0 })
            });
          });
      addPromise
        .then(function () {
          window.dispatchEvent(new CustomEvent("clvry:cart-added"));
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          window.location.href = "/cart";
        })
        .catch(function (err) {
          showError(err.message);
        })
        .finally(function () {
          atcLabel.classList.remove("vc-hidden");
          atcSpinner.classList.add("vc-hidden");
          updateAddToCartState();
        });
    });

    function showError(msg) {
      atcError.textContent = msg;
      atcError.classList.remove("vc-hidden");
    }

    // --- Step-by-step navigation (Garment -> Your verse -> Review) ---
    //
    // Plain show/hide + a small history stack, not a router — Back
    // always pops whatever step was actually shown before (not a
    // hardcoded "current minus 1"), which is what makes the Logo Only
    // skip-step-2 case work without separate back-target wiring: step
    // 1's Continue can jump straight to 3 when no verse is needed (see
    // verseRequiredNow() below), and Back from 3 still correctly lands
    // on 1, because 2 was never pushed onto the history in that case.
    var stepHistory = [1];
    var linkPrefilled = false; // true when a ?verse= link has already chosen the verse

    function showStep(n) {
      // CSS (phones) uses this to switch the preview between big and compact.
      root.setAttribute("data-vc-step", String(n));
      // The preview box changes size between steps on phones; re-fit the verse to it.
      if (typeof renderPreview === "function") {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { if (selected && selected.text) renderPreview(false); });
        });
      }
      Array.prototype.forEach.call(stepPanels, function (panel) {
        panel.classList.toggle("vc-hidden", panel.dataset.stepPanel !== String(n));
      });
      Array.prototype.forEach.call(stepNodes, function (node) {
        var nodeN = Number(node.dataset.stepNode);
        node.classList.toggle("vc-step-node--active", nodeN === n);
        node.classList.toggle("vc-step-node--done", nodeN < n);
      });
      if (stepIntroEl) stepIntroEl.textContent = STEP_INTROS[n] || "";
      // Scrolls the step HEADER (not the panel) into view — keeps the
      // numbered progress indicator as the anchor point, so it reads as
      // "you're now on step 2" rather than landing wherever the next
      // panel's own content happens to start.
      var headerEl = root.querySelector("[data-step-header]");
      if (headerEl && !quietStepChange) headerEl.scrollIntoView({ behavior: "smooth", block: "start" });
      saveDraft();
    }

    Array.prototype.forEach.call(stepNextBtns, function (btn) {
      btn.addEventListener("click", function () {
        var target = Number(btn.dataset.stepNext);
        // Nothing to fill in on step 2 at all for Logo Only / small-
        // format items — skip straight to Review rather than showing
        // an empty verse-picker step with nothing to do on it.
        if (target === 2 && !verseRequiredNow()) target = 3;
        // A ?verse= link has already chosen the verse: skip the verse step.
        if (target === 2 && linkPrefilled && selected && selected.text) target = 3;
        stepHistory.push(target);
        showStep(target);
      });
    });

    Array.prototype.forEach.call(stepBackBtns, function (btn) {
      btn.addEventListener("click", function () {
        stepHistory.pop(); // drop the step being left
        var prev = stepHistory[stepHistory.length - 1] || 1;
        showStep(prev);
      });
    });

    showStep(1);

    // --- Verse-picker gating ---
    //
    // Reactive (not just an init-time check) because Tee/Hoodie can flip
    // in and out of "no verse needed" as the customer changes the Print
    // option — Cap/Socks never change (fullVerse is static per product),
    // but verseRequiredNow() covers both cases from one place.
    var modeTabsEl = root.querySelector(".vc-mode-tabs");
    var citationStripEl = root.querySelector(".vc-citation-strip");
    function applyVerseGate() {
      var required = verseRequiredNow();
      // A selection made while hidden would otherwise be silently
      // discarded on Add to Cart (see the addBtn handler, which only
      // attaches verse properties when verseRequiredNow() is true).
      modeTabsEl.classList.toggle("vc-hidden", !required);
      popularForm.classList.toggle("vc-hidden", !required || mode !== "popular");
      manualForm.classList.toggle("vc-hidden", !required || mode !== "manual");
      mysteryForm.classList.toggle("vc-hidden", !required || mode !== "mystery");
      citationStripEl.classList.toggle("vc-hidden", !required);
      if (reviewVerseTextEl) reviewVerseTextEl.classList.toggle("vc-hidden", !required);

      // Logo Only skips the verse step, so the progress bar shouldn't promise it:
      // hide step 2 (and the connector after it) and renumber Review as step 2.
      var node2 = root.querySelector('[data-step-node="2"]');
      var node3Circle = root.querySelector('[data-step-node="3"] .vc-step-circle');
      if (node2) {
        node2.classList.toggle("vc-hidden", !required);
        if (node2.nextElementSibling) node2.nextElementSibling.classList.toggle("vc-hidden", !required);
      }
      if (node3Circle) node3Circle.textContent = required ? "3" : "2";

      // What happens next, matching the Refund and Shipping policies.
      if (purchaseNoteEl) {
        var timing = "Printed in about 2\u20137 business days, then 3\u20135 business days UK delivery.";
        purchaseNoteEl.innerHTML = required
          ? "<strong>Made to order, just for you.</strong> Because your verse is personal to you, it can\u2019t be returned or exchanged unless faulty (see our <a href=\"/policies/refund-policy\">Refund policy</a>). " + timing
          : "<strong>Made to order.</strong> You have 14 days after delivery to cancel (see our <a href=\"/policies/refund-policy\">Refund policy</a>). " + timing;
      }
    }

    // --- Price display ---
    //
    // Dawn's own price block (main-product section, not ours) only ever
    // reflects whatever variant was selected at page load — it has no
    // idea our custom pills changed the selection, since we bypass
    // Dawn's native <variant-selects> component entirely. Never mattered
    // before (every variant of a product shared one price); now that
    // Print changes the price, this has to be done by hand.
    var priceItemEl = document.querySelector('[id^="price-"] .price__regular .price-item--regular');
    var priceTemplate = priceItemEl ? priceItemEl.textContent : null;
    // The express-checkout form's hidden id input — Shopify's dynamic
    // checkout button (PayPal/Shop Pay/etc, see verse-customizer.liquid)
    // reads this at click time. It never sees our custom color/size
    // pills change on its own since this page bypasses Dawn's native
    // <variant-selects> entirely, so it has to be kept in sync by hand,
    // same as the price display just below.
    var expressCheckoutIdInput = document.querySelector(".vc-express-checkout-form input[name=\"id\"]");
    function updatePriceDisplay() {
      var variant = findVariant(colorSel.value, sizeSel.value || sizeValues[0], printValues.length ? printSel.value : null);
      if (!variant) return;
      if (expressCheckoutIdInput) expressCheckoutIdInput.value = variant.id;

      // config.variants comes from {{ product.variants | json }} in the
      // section's inline script — Shopify Liquid serializes money
      // fields as an integer in the smallest currency unit (e.g. 2999
      // for £29.99), not a decimal string like the Admin REST API
      // returns. Divide by 100 before formatting, or this shows "£2999.00".
      var pounds = Number(variant.price) / 100;
      // Swap just the numeric part, keeping whatever currency symbol/
      // code Shopify already rendered (e.g. "£29.99" or "£29.99 GBP")
      // instead of hard-coding a format that might not match the
      // store's actual money_format setting.
      var formatted = priceTemplate ? priceTemplate.replace(/[\d,]+\.\d+/, pounds.toFixed(2)) : pounds.toFixed(2);

      if (priceItemEl && priceTemplate) priceItemEl.textContent = formatted;

      // Step 3's review ledger and the preview panel's meta line share
      // this same color/size/price data — kept in sync here rather than
      // their own listeners, since this function already runs on every
      // event that could change any of it.
      if (reviewGarmentEl) reviewGarmentEl.textContent = garment + (colorSel.value ? " — " + colorSel.value : "");
      if (reviewSizeEl) reviewSizeEl.textContent = sizeSel.value || "—";
      if (reviewThumbEl) {
        var thumbSrc = (verseRequiredNow() ? teePhotoBack : teePhotoFront);
        if (thumbSrc && thumbSrc.getAttribute("src")) reviewThumbEl.src = thumbSrc.getAttribute("src");
      }
      if (reviewPriceEl) reviewPriceEl.textContent = formatted;
      if (previewMetaSubEl) {
        previewMetaSubEl.textContent = [colorSel.value, sizeSel.value, formatted].filter(Boolean).join(" · ");
      }
    }

    // --- Init ---

    if (printValues.length) {
      printSel.addEventListener("change", function () {
        // Switching TO Verse Backprint should show the verse being
        // customized, not silently leave the preview on whatever view
        // Logo Only left it on (that branch of applyViewState() forces
        // "front" — real user feedback found people didn't realize they
        // had to click "Back" themselves to see their own print).
        if (verseRequiredNow()) currentView = "back";
        applyVerseGate();
        applyViewState();
        if (typeof resetZoomAndPan === "function") resetZoomAndPan();
        updateAddToCartState();
        updatePriceDisplay();
      });
    }
    colorSel.addEventListener("change", updatePriceDisplay);
    sizeSel.addEventListener("change", updatePriceDisplay);

    applyVerseGate();
    updateGarmentChrome();
    updatePriceDisplay();
    clearSelection();

    // --- Remembering choices (draft) and editing from the cart ---
    //
    // 1) Draft: colour, size, print style, verse and step are saved in this
    //    browser (per product page) as the customer goes, and put back when they
    //    return, so clicking away by accident never means starting again.
    //    Cleared on add to cart, or with the "Start over" button.
    // 2) ?vc_edit=<cart line key>: re-opens a cart line with its choices filled in.
    var quietStepChange = false;
    var DRAFT_KEY = "clvry-draft:" + window.location.pathname;
    var DRAFT_MAX_AGE_MS = 14 * 24 * 60 * 60 * 1000;
    var draftReady = false;

    function draftStorage() {
      try { return window.localStorage; } catch (e) { return null; }
    }
    function clearDraft() {
      var st = draftStorage();
      try { if (st) st.removeItem(DRAFT_KEY); } catch (e) {}
    }
    function saveDraft() {
      if (!draftReady || editLine) return;
      var st = draftStorage();
      if (!st) return;
      var step = Number(root.getAttribute("data-vc-step")) || 1;
      var state = {
        t: Date.now(),
        color: colorSel.value,
        size: sizeSel.value,
        print: printValues.length ? printSel.value : "",
        verse: selected && selected.text ? { text: selected.text, reference: selected.reference, translation: selected.translation } : null,
        step: step
      };
      // Nothing worth keeping yet (still on step 1 with only defaults).
      if (!state.verse && !state.size && step === 1) { clearDraft(); return; }
      try { st.setItem(DRAFT_KEY, JSON.stringify(state)); } catch (e) {}
    }
    window.addEventListener("clvry:cart-added", clearDraft);

    function applyState(st, opts) {
      opts = opts || {};
      function setSel(sel, value) {
        if (value && Array.prototype.some.call(sel.options, function (o) { return o.value === value; })) {
          sel.value = value;
          sel.dispatchEvent(new Event("change"));
        }
      }
      if (printValues.length) setSel(printSel, st.print);
      if (!opts.keepColor) setSel(colorSel, st.color);
      setSel(sizeSel, st.size);

      if (verseRequiredNow() && st.verse && st.verse.text) {
        selected = { text: st.verse.text, reference: st.verse.reference || "", translation: st.verse.translation || "kjv" };
        syncPopularToSelected();
        renderPreview(false);
      }
      var step = Number(st.step) || 1;
      if (step === 2 && !verseRequiredNow()) step = 3;
      if (step === 3 && verseRequiredNow() && !selected.text) step = 2;
      if (step === 3 && !sizeSel.value) step = 1;
      stepHistory = step === 1 ? [1] : step === 2 ? [1, 2] : (verseRequiredNow() ? [1, 2, 3] : [1, 3]);
      showStep(step);
    }

    function addBanner(text, withStartOver) {
      var banner = document.createElement("div");
      banner.className = "vc-edit-banner";
      var msg = document.createElement("span");
      msg.textContent = text;
      banner.appendChild(msg);
      if (withStartOver) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "vc-edit-banner-btn";
        btn.textContent = "Start over";
        btn.addEventListener("click", function () {
          clearDraft();
          window.location.href = window.location.pathname;
        });
        banner.appendChild(btn);
      }
      var headerEl = root.querySelector("[data-step-header]");
      if (headerEl && headerEl.parentNode) headerEl.parentNode.insertBefore(banner, headerEl);
    }

    // --- Pre-filled links: ?verse=Romans+8:28[&translation=niv][&colour=Black][&size=M] ---
    // Opens the page with the verse (and optionally colour and size) already chosen, by
    // driving the same "Any Verse" controls a customer would use, so the cart gets exactly
    // what a typed choice would. Anything missing or not found leaves the page as normal.
    var LINK_BOOK_ALIASES = { psalm: "psalms", "song of songs": "song of solomon", songs: "song of solomon", revelations: "revelation",
      tobias: "tobit", ecclesiasticus: "sirach", "wisdom of solomon": "wisdom", "1 machabees": "1 maccabees", "2 machabees": "2 maccabees" };
    function linkWait(test, ms) {
      return new Promise(function (resolve) {
        var t0 = Date.now();
        (function poll() {
          var ok = false;
          try { ok = !!test(); } catch (e) {}
          if (ok) return resolve(true);
          if (Date.now() - t0 > ms) return resolve(false);
          setTimeout(poll, 100);
        })();
      });
    }
    function linkFire(el, value) { el.value = value; el.dispatchEvent(new Event("change", { bubbles: true })); }
    function linkHasOption(sel, value) {
      return Array.prototype.some.call(sel.options, function (o) { return o.value === String(value); });
    }
    function linkParseRef(text) {
      var m = String(text || "").trim().replace(/[–—]/g, "-").match(/^(.+?)\s+(\d+)\s*:\s*(\d+)(?:\s*-\s*(\d+))?$/);
      if (!m) return null;
      return { book: m[1].trim(), chapter: parseInt(m[2], 10), from: parseInt(m[3], 10), to: m[4] ? parseInt(m[4], 10) : null };
    }
    function linkUndo() {
      try { linkFire(bookSel, ""); } catch (e) {}
      var popularTab = root.querySelector('.vc-mode-tab[data-mode="popular"]');
      if (popularTab) popularTab.click();
    }
    // On a pre-filled link the verse step is skipped, so give the Review step a way back to it.
    function addChangeVerseButton() {
      var banner = root.querySelector(".vc-edit-banner");
      if (!banner) return;
      var startOver = banner.querySelector(".vc-edit-banner-btn");
      var change = document.createElement("button");
      change.type = "button";
      change.className = "vc-edit-banner-btn vc-edit-banner-change";
      change.textContent = "Change verse";
      change.addEventListener("click", function () {
        linkPrefilled = false; // from here the normal steps apply again
        stepHistory = [1, 2];
        if (banner.parentNode) banner.parentNode.removeChild(banner);
        showStep(2);
      });
      banner.insertBefore(change, startOver);
    }
    function applyVerseLink(params) {
      var ref = linkParseRef(params.get("verse"));
      if (!ref) return Promise.resolve(false);
      var tr = String(params.get("translation") || "niv").toLowerCase();
      if (!TRANSLATION_NAMES[tr] || !linkHasOption(translationSel, tr)) tr = "niv";
      var want = LINK_BOOK_ALIASES[ref.book.toLowerCase()] || ref.book.toLowerCase();
      var bookDef = BOOKS.filter(function (b) { return b.name.toLowerCase() === want; })[0];
      if (!bookDef) return Promise.resolve(false);
      if (bookDef.catholic) tr = "dra"; // the Catholic books exist in the Douay-Rheims only

      var manualTab = root.querySelector('.vc-mode-tab[data-mode="manual"]');
      if (manualTab) manualTab.click();
      linkFire(translationSel, tr);
      var bookOpt = Array.prototype.filter.call(bookSel.options, function (o) { return o.value === bookDef.id; })[0];
      if (!bookOpt) { linkUndo(); return Promise.resolve(false); }
      linkFire(bookSel, bookOpt.value);
      return linkWait(function () { return !chapterSel.disabled && chapterSel.options.length > 1 && linkHasOption(chapterSel, ref.chapter); }, 15000)
        .then(function (ok) {
          if (!ok) return false;
          linkFire(chapterSel, String(ref.chapter));
          return linkWait(function () { return !verseFromSel.disabled && linkHasOption(verseFromSel, ref.from); }, 15000);
        })
        .then(function (ok) {
          if (!ok) return false;
          linkFire(verseFromSel, String(ref.from));
          if (ref.to && ref.to !== ref.from) {
            if (!linkHasOption(verseToSel, ref.to)) return false;
            linkFire(verseToSel, String(ref.to));
          }
          return linkWait(function () { return selected && selected.text; }, 5000);
        })
        .then(function (ok) { if (!ok) linkUndo(); return ok; })
        .catch(function () { linkUndo(); return false; });
    }

    (function restore() {
      var params = null;
      try { params = new URLSearchParams(window.location.search); } catch (e) {}
      var editKey = params && params.get("vc_edit");

      if (editKey) {
        fetch("/cart.js", { headers: { Accept: "application/json" } })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            var line = (cart.items || []).filter(function (it) { return it.key === editKey; })[0];
            if (!line || !line.properties) { draftReady = true; return; }
            var p = line.properties;
            editLine = { key: line.key, quantity: line.quantity, variantId: line.variant_id, properties: p };
            var code = "kjv";
            Object.keys(TRANSLATION_NAMES).forEach(function (k) { if (TRANSLATION_NAMES[k] === p.Translation) code = k; });
            atcLabel.textContent = "Update item";
            addBanner("You’re editing an item from your cart. Change anything you like, then continue to the last step and tap “Update item”. Nothing changes in your cart until you do.", false);
            // Opens on step 1 (colour and size) so the choices are right there; their verse is already filled in.
            applyState({ color: p._Color, size: p._Size, print: p._Print, step: 1,
              verse: p.Verse ? { text: p.Verse, reference: p.Reference, translation: code } : null });
            // Stop on the "you're editing" note so it stays in view above the stepper.
            setTimeout(function () {
              var note = root.querySelector(".vc-edit-banner");
              if (note) note.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 700);
          })
          .catch(function () { draftReady = true; });
        return;
      }

      // A pre-filled link (?verse=...) wins over any saved draft.
      var linkVerse = params && params.get("verse");
      if (linkVerse && verseRequiredNow()) {
        var wantSize = params.get("size");
        if (wantSize) {
          var sizeMatch = sizeValues.filter(function (s) { return s.toLowerCase() === String(wantSize).trim().toLowerCase(); })[0];
          if (sizeMatch) { sizeSel.value = sizeMatch; sizeSel.dispatchEvent(new Event("change")); }
        }
        applyVerseLink(params).then(function (ok) {
          if (ok) {
            clearDraft();
            linkPrefilled = true;
            var tName = TRANSLATION_NAMES[selected.translation] || "";
            var label = selected.reference + (tName ? " (" + tName + ")" : "");
            quietStepChange = true;
            if (sizeSel.value) {
              stepHistory = [1, 3];
              showStep(3);
              addBanner("We’ve set this up for you: " + label + ". Check it over, then add it to your cart.", true);
            } else {
              addBanner("We’ve set up " + label + " for you.", true);
            }
            addChangeVerseButton();
            quietStepChange = false;
          }
          draftReady = true;
          saveDraft();
        }).catch(function () { draftReady = true; });
        return;
      }

      var st = draftStorage();
      var saved = null;
      try { saved = st && JSON.parse(st.getItem(DRAFT_KEY) || "null"); } catch (e) {}
      if (saved && saved.t && Date.now() - saved.t < DRAFT_MAX_AGE_MS) {
        quietStepChange = true;
        // A link that names a colour (the home page's rotating images) wins over the saved colour.
        applyState(saved, { keepColor: !!(params && (params.get("color") || params.get("colour"))) });
        quietStepChange = false;
        addBanner("Welcome back — we’ve kept the choices you made last time.", true);
      } else if (saved) {
        clearDraft();
      }
      draftReady = true;
      saveDraft();
    })();

    colorSel.addEventListener("change", saveDraft);
    sizeSel.addEventListener("change", saveDraft);
    if (printValues.length) printSel.addEventListener("change", saveDraft);
  }

  /**
   * On mobile, the full product description (main-product section, not
   * ours) pushed the color strip / customizer form far down the page
   * before a customer saw anything interactive. Collapses it to a few
   * lines with a "Read more" toggle so the customizer appears sooner —
   * desktop is unaffected (the CSS max-height clamp only applies under
   * 750px, see verse-customizer.css).
   */
  function initDescriptionCollapse() {
    var desc = document.querySelector(".product__description");
    if (!desc || desc.dataset.vcCollapseInit) return;
    desc.dataset.vcCollapseInit = "true";

    var toggle = document.createElement("button");
    toggle.type = "button";
    toggle.className = "vc-desc-toggle";
    toggle.textContent = "Read more";
    toggle.setAttribute("aria-expanded", "false");
    desc.insertAdjacentElement("afterend", toggle);

    toggle.addEventListener("click", function () {
      var expanded = desc.classList.toggle("vc-desc-expanded");
      toggle.textContent = expanded ? "Show less" : "Read more";
      toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
    });

    // If the collapsed text doesn't actually overflow (short description,
    // or already-wide desktop viewport), there's nothing to expand —
    // hide the toggle rather than show a button that does nothing.
    function syncToggleVisibility() {
      var overflows = desc.scrollHeight > desc.clientHeight + 1;
      desc.classList.toggle("vc-desc-overflowing", overflows);
      toggle.classList.toggle("vc-hidden", !overflows && !desc.classList.contains("vc-desc-expanded"));
    }
    syncToggleVisibility();
    window.addEventListener("resize", syncToggleVisibility);
  }

  /* Phones: the Back / Continue bar is pinned to the bottom of the screen (CSS) while the steps are in view. Once the
     end of the steps has scrolled off the top, slide it away; it comes back as soon as you scroll up into them. */
  function initNavPin() {
    var mq = window.matchMedia("(max-width: 700px)");
    Array.prototype.forEach.call(document.querySelectorAll(".vc-root"), function (root) {
      var ticking = false;
      function update() {
        ticking = false;
        // Each step has its own Back / Continue bar; use the one that is showing (the others are display:none).
        var nav = Array.prototype.filter.call(root.querySelectorAll(".vc-step-nav"), function (n) { return n.getClientRects().length > 0; })[0];
        var panel = nav && nav.parentElement;
        if (!mq.matches || !panel) { root.classList.remove("vc-nav-away"); return; }
        root.classList.toggle("vc-nav-away", panel.getBoundingClientRect().bottom < 96);
      }
      function queue() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
      window.addEventListener("scroll", queue, { passive: true });
      window.addEventListener("resize", queue);
      update();
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    (window.VC_SECTIONS || []).forEach(initSection);
    initDescriptionCollapse();
    initNavPin();
  });
})();
